var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirektvermarktung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 346,
    viewBox: "0 0 457 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Direktvermarktung"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.81 345.135L0.227356 208.568L0.262268 189.381L38.9174 171.824L252.264 307.879V333.442L236.81 345.135Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.816 345.511L0.227631 208.914V206.376L236.816 343.117V345.511Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.773 218.765L236.814 345.512L236.814 286.552L417.866 187.035L456.757 199.174L456.773 218.765Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.227631 189.432L236.81 326.72L456.758 199.173L220.031 74.3397L0.227631 189.432Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M131.506 187.408L98.7602 206.314L66.0144 187.408L98.7602 168.503L131.506 187.408Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mast"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.508 139.655L181.792 138.909L181.792 138.91L181.767 138.921L163.19 133.828L163.698 134.558L163.117 133.789L160.402 133.044L158.813 133.771L158.83 133.793L156.024 135.129L142.042 126.563L127.774 133.858L127.777 133.862L127.772 133.858L126.184 134.585L134.062 145.505L123.122 150.713L121.532 151.44L121.549 151.462L110.718 156.618L110.68 156.608L110.696 156.629L110.663 156.644L111.784 158.117L110.229 158.829L111.353 160.3L99.1675 166.101L100.505 165.464L113.147 168.808L117.345 168.135L118.094 169.114L116.74 169.759L113.147 168.808L107.876 169.654L113.637 171.236L105.61 175.057L102.32 170.545L107.876 169.654L100.117 167.524L99.1026 166.132L96.4291 165.398L94.8774 166.137L95.9994 167.609L87.1036 171.844L84.4302 171.11L82.8792 171.849L84.0013 173.321L83.4833 173.567L84.1123 173.467L89.7051 180.805L93.267 177.212L83.4833 173.567L87.9204 175.744L80.9463 179.065L91.0353 192.304L100.117 201.033L143.256 177.185L143.244 177.181L144.791 176.444L144.804 176.448L144.799 176.441L154.147 171.991L165.619 187.118L165.638 187.19L165.664 187.177L165.669 187.184L166.948 186.575L165.659 187.194L168.332 187.928L187.048 193.034L187.057 193.046L187.051 193.049L189.724 193.783L191.247 193.052L188.606 192.327L188.609 192.325L191.251 193.05L182.062 158.78L194.487 152.864L184.508 139.655ZM165.631 180.794L165.971 182.061L165.974 182.065L165.632 180.794L165.631 180.794ZM158.441 160.428L156.905 154.716L149.854 158.075L158.441 160.428ZM159.753 165.307L159.093 162.851L149.374 160.131L154.592 167.026L154.575 167.001L155.603 167.283L159.753 165.307ZM163.148 177.932L161.278 170.977L158.154 170.083L157.236 170.52L163.315 178.552L163.311 178.539L162.817 177.841L163.148 177.932ZM169.835 187.168L169.851 187.159L169.803 187.092L169.817 187.144L169.835 187.168ZM168.317 181.547L169.495 185.942L184.865 190.153L181.049 185.116L181.046 185.118L168.317 181.547ZM172.804 174.278L165.832 172.282L167.68 179.173L178.869 182.238L172.829 174.266L172.804 174.278ZM165.197 169.911L164.44 167.09L166.61 166.057L170.665 171.409L165.197 169.911ZM163.367 161.777L162.823 161.058L162.987 161.673L163.367 161.777ZM181.475 182.952L174.35 173.542L174.354 173.54L173.906 172.94L181.49 182.956L181.475 182.952ZM185.917 188.803L182.576 184.39L182.567 184.394L185.924 188.827L185.917 188.803ZM173.276 172.125L173.292 172.129L168.142 165.328L168.133 165.332L173.276 172.125ZM184.748 184.457L178.321 160.56L169.752 164.639L184.748 184.457ZM186.742 185.499L187.404 187.967L187.408 187.972L186.742 185.499ZM165.348 136.743L178.664 140.398L170.902 144.094L165.348 136.743ZM159.616 137.456L163.599 140.036L161.091 136.753L159.616 137.456ZM149.699 138.139L153.633 136.267L143.122 129.447L149.699 138.139ZM165.082 143.695L157.223 138.596L153.301 140.464L165.082 143.695ZM188.14 150.012L182.511 142.604L174.694 146.328L188.14 150.012ZM179.848 155.819L174.342 148.53L187.573 152.142L179.848 155.819ZM142.042 134.111L142.767 134.585L142.506 134.241L142.042 134.111ZM146.898 137.29L146.926 137.308L144.079 133.549L144.069 133.554L146.898 137.29ZM137.225 144.078L142.086 141.764L133.644 139.346L137.225 144.078ZM145.004 140.374L146.414 139.703L134.561 132.012L128.915 135.129L145.004 140.374ZM147.381 143.28L149.654 143.931L154.225 149.916L141.042 146.301L147.381 143.28ZM158.592 149.89L166.119 146.307L153.195 142.758L158.592 149.89ZM140.568 148.495L153.839 152.138L146.11 155.818L140.568 148.495ZM144.544 156.563L137.876 147.756L137.874 147.756L144.544 156.563ZM128.29 152.293L141.95 155.907L136.311 148.471L128.29 152.293ZM133.586 161.716L128.055 154.397L141.315 158.037L133.586 161.716ZM167.52 161.689L175.192 158.037L162.039 154.447L167.52 161.689ZM175.712 155.894L170.103 148.511L162.313 152.223L175.712 155.894ZM123.81 154.423L129.47 161.832L115.83 158.224L123.81 154.423ZM121.175 167.624L121.105 167.532L121.505 167.467L121.175 167.624ZM145.231 160.273L137.27 164.066L150.84 167.656L145.231 160.273ZM142.557 173.494L150.296 169.81L136.972 166.152L142.557 173.494ZM97.4724 182.944L105.435 179.154L111.063 186.539L97.4724 182.944ZM113.707 187.239L115.045 186.602L109.875 179.51L122.602 183.004L113.707 187.239ZM109.47 177.233L117.433 173.442L123.062 180.828L109.47 177.233ZM125.705 181.527L137.852 175.744L121.833 171.347L120.535 171.965L127.043 180.89L125.705 181.527ZM123.316 170.641L132.717 166.166L138.397 173.591L124.72 169.973L123.316 170.641ZM101.295 174.558L98.6818 171.129L92.2389 172.163L101.295 174.558ZM89.7476 172.562L92.2389 172.163L88.5077 171.176L87.1036 171.844L89.7476 172.562ZM89.7476 172.562L87.1036 171.844L87.8496 172.867L89.7476 172.562ZM88.1186 173.236L101.639 176.947L92.1366 181.471L92.1382 181.473L92.1344 181.472L92.2079 181.437L93.6118 180.769L88.1186 173.236ZM110.604 188.716L96.9022 184.954L102.653 192.501L110.604 188.716Z",
    fill: "url(#paint0_linear_820_10110)",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pfeile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 328",
    d: "M150.989 148.314L302.859 233.634V238.085L150.989 152.765V148.314Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 329",
    d: "M150.989 148.312L112.739 170.657V175.083L150.989 152.738V148.312Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 330",
    d: "M148.604 162.781L300.474 248.101L293.929 251.113L148.604 167.213V162.781Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 331",
    d: "M148.662 162.7L110.412 185.045L117.309 184.939L148.662 167.141V162.7Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dot-direktvermarktung-links"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    cx: 198.078,
    cy: 193.411,
    r: 6.31184,
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dot-direktvermarktung-rechts"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dot_2",
    cx: 160.234,
    cy: 156.241,
    r: 6.31184,
    fill: "#B4005F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Strommast mit Kabel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mast_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mast_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M120.59 174.805L98.7601 162.2L76.9305 174.805L98.7601 187.408L120.59 174.805Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M120.59 174.805V187.408L98.7601 200.012V187.408L120.59 174.805Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M98.7603 200.012L76.9307 187.408V174.805L98.7603 187.408V200.012Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M98.7603 145.024V142.22L81.7859 152.144V154.825L98.7603 145.024Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M98.7603 142.22L96.3326 140.818L81.7859 149.608V152.144L98.7603 142.22Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M101.188 163.598V94.2769L98.7603 95.6788V165L101.188 163.598Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M96.3326 163.598V94.2769L98.7603 95.6788V165L96.3326 163.598Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M98.7603 123.343V120.539L81.7859 130.344V133.142L98.7603 123.343Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M98.7603 120.539L96.3326 119.137L81.7859 127.926V130.461L98.7603 120.539Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M98.7602 145.024V142.22L115.735 152.144V154.825L98.7602 145.024Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M98.7602 142.22L101.188 140.818L115.735 149.608V152.144L98.7602 142.22Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M98.7602 123.343V120.539L115.735 130.461V133.142L98.7602 123.343Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M98.7602 120.539L101.188 119.137L115.735 127.926V130.461L98.7602 120.539Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M120.59 174.805V105.485L118.162 106.887V176.207L120.59 174.805Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M115.735 174.805V105.485L118.162 106.887V176.207L115.735 174.805Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M101.188 186.006V116.686L98.7603 118.088V187.408L101.188 186.006Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M96.3326 186.006L96.3617 113.891L98.7907 115.293L98.7602 187.408L96.3326 186.006Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M81.7858 174.805V105.485L79.3582 106.887V176.207L81.7858 174.805Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M76.9306 174.805L76.964 102.745L79.3916 104.147L79.3582 176.207L76.9306 174.805Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M98.7603 73.2712V70.4673L81.7859 80.2722V83.0703L98.7603 73.2712Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M98.7603 70.4672L96.3326 69.0652L81.7859 77.8531V80.3897L98.7603 70.4672Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M98.7603 95.7847V92.9808L81.7859 102.786V105.585L98.7603 95.7847Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M98.7603 92.9812L96.3326 91.5792L81.7859 100.369V102.905L98.7603 92.9812Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M118.162 156.231V153.427L101.188 163.351V166.032L118.162 156.231Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M118.162 153.427L115.735 152.025L101.188 160.814V163.351L118.162 153.427Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M118.162 134.55V131.746L101.188 141.67V144.35L118.162 134.55Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M118.162 131.746L115.735 130.344L101.188 139.133V141.67L118.162 131.746Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M79.3582 156.349V153.546L96.3326 163.469V166.149L79.3582 156.349Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M79.3582 153.546L81.7858 152.144L96.3326 160.932V163.469L79.3582 153.546Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M79.3582 134.667V131.864L96.3326 141.788V144.468L79.3582 134.667Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M79.3582 131.863L81.7858 130.461L96.3326 139.251V141.787L79.3582 131.863Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M79.3582 106.926L79.3931 104.105L98.7311 115.293L98.7325 118.072L79.3582 106.926Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M76.9306 102.681L79.3597 101.279L101.159 113.891L98.7311 115.293L76.9306 102.681Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M98.7603 95.7283L98.8169 92.8983L118.162 104.091L118.164 106.886L98.7603 95.7283Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M96.3616 91.4773L98.7906 90.0768L120.59 102.688L118.162 104.09L96.3616 91.4773Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M120.578 105.584V80.2591L118.149 81.661V106.986L120.578 105.584Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M115.722 102.713V80.2591L118.149 81.661V104.115L115.722 102.713Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M101.271 91.5137L101.265 69.0043L98.8096 70.4236V92.9346L101.271 91.5137Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M96.382 91.534V69.0217L98.8096 70.4236V92.9345L96.382 91.534Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M96.382 71.7922V69.0188L118.149 81.6609V84.3994L96.382 71.7922Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M96.382 69.0188L98.8474 67.5965L120.578 80.259L118.149 81.6609L96.382 69.0188Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M101.162 113.941V91.4863L98.7326 92.8882V115.342L101.162 113.941Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M96.3049 113.941V91.4863L98.7325 92.8882V115.342L96.3049 113.941Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M81.8541 102.741L81.8483 80.2328L79.3931 81.6508V104.163L81.8541 102.741Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M76.9655 102.761V80.2488L79.3931 81.6508V104.163L76.9655 102.761Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M76.9291 83.0673L76.9655 80.246L98.7325 92.8881V95.6266L76.9291 83.0673Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M76.9655 80.2459L79.4295 78.8237L101.162 91.4861L98.7326 92.8881L76.9655 80.2459Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M118.162 106.992V104.188L101.188 114.112V116.792L118.162 106.992Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M118.162 104.188L115.735 102.786L101.188 111.575V114.112L118.162 104.188Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M118.162 84.4778V81.6739L101.188 91.5964V94.2768L118.162 84.4778Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M118.162 81.6742L115.735 80.2722L101.188 89.0616V91.5967L118.162 81.6742Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M120.578 80.2488V57.7945L118.149 59.1964V81.6507L120.578 80.2488Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M115.722 80.2488V57.7945L118.149 59.1964V81.6507L115.722 80.2488Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M101.271 69.0494L101.265 46.54L98.8096 47.9593V70.4703L101.271 69.0494Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M96.382 69.0683V46.5574L98.8096 47.9593V70.4702L96.382 69.0683Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M51.6274 23.2068V20.4349L165.013 86.3434V89.0819L51.6274 23.2068Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M96.382 46.5545L98.8474 45.1322L120.578 57.7947L118.149 59.1966L96.382 46.5545Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M51.616 20.4087L54.0814 18.9849L167.429 84.9196L165.002 86.3215L51.616 20.4087Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M98.8096 50.7629V47.959L81.8353 57.7639V60.5634L98.8096 50.7629Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M98.8096 47.9593L96.382 46.5574L79.4295 56.3593L81.8353 57.8833L98.8096 47.9593Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M51.456 23.0728L51.4909 20.2515L96.4793 24.1507V26.8892L51.456 23.0728Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M51.4924 20.2489L54.2687 19.0154L98.9099 22.752L96.4809 24.1525L51.4924 20.2489Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M118.149 62.0004V59.1965L101.259 68.9752L103.479 70.2624L118.149 62.0004Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M118.149 59.1965L115.841 57.8353L98.8474 67.6735L101.095 69.0697L118.149 59.1965Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M120.673 57.9004V35.4462L118.245 36.8481V59.3024L120.673 57.9004Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M115.818 57.9004V35.4462L118.245 36.8481V59.3024L115.818 57.9004Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M101.367 46.7011L101.359 24.1931L98.9055 25.611V48.1234L101.367 46.7011Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M96.4765 46.7215V24.2091L98.9055 25.611V48.1234L96.4765 46.7215Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M96.4766 26.9796V24.2062L118.245 36.8484V39.5869L96.4766 26.9796Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M96.4765 24.2062L98.9418 22.7839L120.673 35.4464L118.245 36.8484L96.4765 24.2062Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M84.055 42.2888V39.4849L66.9993 49.3581L69.0986 50.4593L84.055 42.2888Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M84.055 39.485L81.7451 38.1237L64.7519 47.962L66.9993 49.3581L84.055 39.485Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M68.2691 32.7964V29.9926L51.2134 39.8657L52.826 41.4696L68.2691 32.7964Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M68.2691 29.9925L65.9592 28.6313L48.966 38.4696L51.2134 39.8657L68.2691 29.9925Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M53.9214 24.3603V21.5564L36.8657 31.4295L36.9209 34.2523L53.9214 24.3603Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M53.9214 21.5564L51.6114 20.1951L34.6182 30.0334L36.8657 31.4295L53.9214 21.5564Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M101.162 91.4759V69.0217L98.7326 70.4236V92.8779L101.162 91.4759Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M96.3049 91.4759V69.0217L98.7325 70.4236V92.8779L96.3049 91.4759Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M81.8541 80.2766L81.8483 57.7686L79.3931 59.1865V81.6988L81.8541 80.2766Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M76.9655 80.2969V57.7845L79.3931 59.1865V81.6988L76.9655 80.2969Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M32.1762 34.4815L32.2111 31.6617L145.597 97.5702V100.309L32.1762 34.4815Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M32.2126 31.6591L34.9889 30.4242L148.026 96.17L145.598 97.5719L32.2126 31.6591Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M32.176 34.4815L32.2109 31.6617L77.1993 35.561V38.2995L32.176 34.4815Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M32.2126 31.659L34.6184 30.0333L79.6301 34.1607L77.2025 35.5626L32.2126 31.659Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M98.8096 28.6065V25.8027L81.8353 35.6075V38.4056L98.8096 28.6065Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M98.8096 25.8029L96.382 24.4009L79.4295 34.2029L81.8353 35.7254L98.8096 25.8029Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M101.256 69.1276V46.6733L98.8285 48.0753V70.5295L101.256 69.1276Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M96.401 69.1276V46.6733L98.8286 48.0753V70.5295L96.401 69.1276Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M81.95 57.9283L81.9427 35.4203L79.489 36.8382V59.3506L81.95 57.9283Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M77.0599 57.9486V35.4363L79.489 36.8382V59.3506L77.0599 57.9486Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M77.0252 38.2547L77.0601 35.4348L98.8286 48.0755V50.814L77.0252 38.2547Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M77.06 35.4348L79.5253 34.0111L101.256 46.6736L98.8285 48.0755L77.06 35.4348Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M118.244 39.6216V36.8177L101.256 46.6429V49.4991L118.244 39.6216Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M118.244 36.8177L115.935 35.4565L98.942 45.2947L101.189 46.6909L118.244 36.8177Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M120.673 35.477V13.0227L118.244 14.4246V36.8789L120.673 35.477Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M115.816 35.477V13.0227L118.244 14.4246V36.8789L115.816 35.477Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M101.365 24.2773L101.359 1.76929L98.904 3.18721V25.6996L101.365 24.2773Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M96.4764 24.2976V1.78528L98.9041 3.18722V25.6996L96.4764 24.2976Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M96.4766 4.55579V1.78387L118.244 14.4246V17.1631L96.4766 4.55579Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M96.4765 1.78384L98.9418 0.360107L120.673 13.0226L118.244 14.4245L96.4765 1.78384Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M98.9928 5.98375V3.17987L82.0199 12.9847V15.7828L98.9928 5.98375Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M98.9928 3.18008L96.5652 1.77814L79.6141 11.5801L82.0199 13.1026L98.9928 3.18008Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M101.256 46.7041V24.2499L98.827 25.6518V48.1061L101.256 46.7041Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M96.3995 46.7041V24.2499L98.8271 25.6518V48.1061L96.3995 46.7041Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M81.9485 35.5045L81.9427 12.9965L79.4875 14.4144V36.9267L81.9485 35.5045Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M77.0601 35.5248V13.0125L79.4877 14.4144V36.9268L77.0601 35.5248Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M77.0237 15.8308L77.0601 13.011L98.8271 25.6517V28.3902L77.0237 15.8308Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M77.06 13.011L79.5253 11.5873L101.256 24.2498L98.827 25.6517L77.06 13.011Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M118.287 17.2198V14.4174L101.3 24.2425V27.0987L118.287 17.2198Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M118.287 14.4173L115.979 13.056L98.9853 22.8928L101.231 24.289L118.287 14.4173Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M167.436 87.6884L167.429 84.9267L165.001 86.3286L165.009 89.0904L167.436 87.6884Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M148.032 98.9345L148.024 96.1727L145.595 97.5747L145.604 100.336L148.032 98.9345Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M118.206 36.8976L120.671 35.4753L167.429 84.9194L165.002 86.3213L118.206 36.8976Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M118.261 39.6886V36.9167L165.013 86.3434V89.0819L118.261 39.6886Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M134.092 71.1629V68.3605L117.036 78.2322L119.135 79.3348L134.092 71.1629Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M134.092 68.3608L131.782 66.9996L114.789 76.8364L117.036 78.2325L134.092 68.3608Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M151.954 81.5013V78.6974L134.898 88.5706L136.511 90.1745L151.954 81.5013Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M151.954 78.6974L149.644 77.3361L132.651 87.1744L134.898 88.5705L151.954 78.6974Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M165.031 89.0426V86.2387L147.976 96.1118L148.031 98.9346L165.031 89.0426Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M165.031 86.2387L162.722 84.8788L145.729 94.7157L147.976 96.1118L165.031 86.2387Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M98.7792 48.1655L101.245 46.7432L148.002 96.1873L145.575 97.5893L98.7792 48.1655Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M98.8356 50.9562V48.1843L145.586 97.611V100.349L98.8356 50.9562Z",
    fill: "#747773"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M425.363 198.023C431.822 200.688 431.822 205.085 425.363 207.865C418.088 210.587 409.48 210.587 402.206 207.865C395.748 205.201 395.748 200.803 402.206 198.023C409.48 195.302 418.088 195.302 425.363 198.023Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M413.425 202.748L409.982 182.054C410.064 182.898 409.643 183.542 408.718 184.123C406.966 185.225 404.062 185.377 402.232 184.41C401.281 183.908 400.808 183.247 400.818 182.553L400.816 182.553L398.74 204.147C398.632 205.364 399.403 206.566 401.041 207.432C404.03 209.011 408.775 208.811 411.637 207.011C413.549 205.809 414.135 204.164 413.425 202.748Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M397.53 142.883C407.106 142.883 414.869 150.889 414.869 160.763C414.869 170.638 407.106 178.644 397.53 178.644C387.954 178.644 380.192 170.638 380.192 160.763C380.192 150.889 387.954 142.883 397.53 142.883Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M407.319 156.626C401.612 159.753 392.366 159.753 386.659 156.626C384.058 155.236 382.686 153.36 382.397 151.552C382.107 153.846 383.48 156.139 386.659 157.876C392.366 161.003 401.612 161.003 407.319 157.876C410.426 156.139 411.87 153.845 411.581 151.552C411.292 153.429 409.921 155.233 407.319 156.626Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M408.849 169.18C402.297 172.698 391.681 172.698 385.129 169.18C382.143 167.617 380.567 165.506 380.235 163.473C379.903 166.053 381.479 168.632 385.129 170.587C391.681 174.105 402.297 174.105 408.849 170.587C412.417 168.632 414.075 166.052 413.744 163.473C413.411 165.583 411.837 167.614 408.849 169.18Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M412.702 151.552C422.277 151.552 430.04 159.558 430.04 169.433C430.04 179.307 422.277 187.313 412.702 187.313C403.125 187.313 395.363 179.307 395.363 169.433C395.363 159.558 403.125 151.552 412.702 151.552Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M423.414 165.295C417.496 168.422 407.908 168.422 401.99 165.295C399.292 163.905 397.869 162.029 397.57 160.222C397.269 162.516 398.693 164.808 401.99 166.545C407.908 169.673 417.496 169.673 423.414 166.545C426.637 164.808 428.135 162.515 427.835 160.222C427.535 162.098 426.113 163.902 423.414 165.295Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M425.104 177.849C418.552 181.368 407.936 181.368 401.384 177.849C398.398 176.286 396.822 174.175 396.49 172.142C396.158 174.723 397.734 177.301 401.384 179.256C407.936 182.774 418.552 182.774 425.104 179.256C428.672 177.301 430.33 174.721 429.999 172.142C429.666 174.253 428.092 176.283 425.104 177.849Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M397.531 166.724C404.114 166.724 409.451 172.303 409.451 179.186C409.451 186.068 404.114 191.648 397.531 191.648C390.947 191.648 385.61 186.068 385.61 179.186C385.61 172.303 390.947 166.724 397.531 166.724Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M404.258 177.031C400.242 179.376 393.736 179.376 389.72 177.031C387.89 175.988 386.924 174.581 386.721 173.226C386.517 174.946 387.483 176.665 389.72 177.968C393.736 180.314 400.242 180.314 404.258 177.968C406.445 176.665 407.461 174.945 407.258 173.226C407.054 174.633 406.089 175.986 404.258 177.031Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M405.948 185.7C401.298 188.045 393.764 188.045 389.114 185.7C386.995 184.658 385.876 183.25 385.641 181.895C385.405 183.615 386.524 185.335 389.114 186.638C393.764 188.983 401.298 188.983 405.948 186.638C408.48 185.335 409.657 183.614 409.421 181.895C409.185 183.302 408.068 184.655 405.948 185.7Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M226.452 106.458C232.911 109.123 232.911 113.521 226.452 116.3C219.177 119.022 210.569 119.022 203.295 116.3C196.837 113.636 196.837 109.238 203.295 106.458C210.569 103.737 219.177 103.737 226.452 106.458Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M214.515 111.183L211.071 90.4888C211.154 91.3334 210.732 91.9768 209.807 92.5583C208.055 93.6601 205.151 93.8121 203.321 92.8452C202.37 92.3435 201.898 91.6819 201.907 90.9883L201.905 90.9884L199.83 112.582C199.721 113.799 200.492 115.001 202.13 115.867C205.119 117.446 209.864 117.246 212.726 115.446C214.638 114.244 215.224 112.599 214.515 111.183Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M198.619 51.3182C208.195 51.3182 215.958 59.3239 215.958 69.1985C215.958 79.0731 208.195 87.0788 198.619 87.0788C189.043 87.0788 181.281 79.0731 181.281 69.1985C181.281 59.3239 189.043 51.3182 198.619 51.3182Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M208.408 65.0609C202.701 68.1881 193.455 68.1881 187.748 65.0609C185.147 63.6712 183.775 61.795 183.486 59.9875C183.196 62.2815 184.569 64.5738 187.748 66.3113C193.455 69.4385 202.701 69.4385 208.408 66.3113C211.515 64.5738 212.96 62.2803 212.671 59.9875C212.381 61.8637 211.01 63.6683 208.408 65.0609Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M209.938 77.6153C203.386 81.1334 192.77 81.1334 186.218 77.6153C183.232 76.0519 181.656 73.9411 181.324 71.9077C180.992 74.4885 182.568 77.0673 186.218 79.022C192.77 82.5402 203.386 82.5402 209.938 79.022C213.506 77.0673 215.164 74.4872 214.833 71.9077C214.5 74.0185 212.926 76.0486 209.938 77.6153Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M213.791 59.9875C223.366 59.9875 231.129 67.9932 231.129 77.8678C231.129 87.7424 223.366 95.7481 213.791 95.7481C204.215 95.7481 196.452 87.7424 196.452 77.8678C196.452 67.9932 204.215 59.9875 213.791 59.9875Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M224.504 73.7301C218.585 76.8574 208.997 76.8574 203.079 73.7301C200.382 72.3404 198.958 70.4642 198.659 68.6567C198.358 70.9508 199.782 73.243 203.079 74.9806C208.997 78.1078 218.585 78.1078 224.504 74.9806C227.726 73.243 229.224 70.9496 228.924 68.6567C228.624 70.533 227.202 72.3375 224.504 73.7301Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M226.193 86.2845C219.641 89.8027 209.025 89.8027 202.473 86.2845C199.487 84.7211 197.911 82.6104 197.579 80.577C197.247 83.1577 198.823 85.7365 202.473 87.6913C209.025 91.2094 219.641 91.2094 226.193 87.6913C229.761 85.7365 231.419 83.1564 231.088 80.577C230.755 82.6877 229.181 84.7178 226.193 86.2845Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M198.62 75.1587C205.203 75.1587 210.54 80.7384 210.54 87.6207C210.54 94.503 205.203 100.083 198.62 100.083C192.036 100.083 186.699 94.503 186.699 87.6207C186.699 80.7384 192.036 75.1587 198.62 75.1587Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M205.347 85.4657C201.331 87.8111 194.825 87.8111 190.809 85.4657C188.979 84.4234 188.013 83.0163 187.81 81.6606C187.606 83.3812 188.572 85.1003 190.809 86.4035C194.825 88.7489 201.331 88.7489 205.347 86.4035C207.534 85.1003 208.55 83.3803 208.347 81.6606C208.143 83.0678 207.178 84.4212 205.347 85.4657Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M207.037 94.1349C202.387 96.4804 194.853 96.4804 190.203 94.1349C188.084 93.0927 186.966 91.6855 186.73 90.3299C186.494 92.0504 187.613 93.7696 190.203 95.0728C194.853 97.4182 202.387 97.4182 207.037 95.0728C209.569 93.7696 210.746 92.0495 210.51 90.3299C210.275 91.7371 209.157 93.0905 207.037 94.1349Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M270.357 107.423C276.816 110.088 276.816 114.485 270.357 117.265C263.081 119.986 254.473 119.986 247.199 117.265C240.742 114.601 240.742 110.203 247.199 107.423C254.473 104.701 263.081 104.701 270.357 107.423Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M258.419 112.148L254.975 91.4532C255.058 92.2979 254.637 92.9412 253.712 93.5228C251.96 94.6246 249.055 94.7766 247.225 93.8097C246.274 93.308 245.802 92.6464 245.811 91.9528L245.809 91.9529L243.734 113.546C243.625 114.764 244.396 115.966 246.034 116.831C249.023 118.411 253.768 118.21 256.63 116.41C258.542 115.208 259.128 113.563 258.419 112.148Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M242.524 52.2827C252.099 52.2827 259.862 60.2884 259.862 70.163C259.862 80.0376 252.099 88.0433 242.524 88.0433C232.947 88.0433 225.185 80.0376 225.185 70.163C225.185 60.2884 232.947 52.2827 242.524 52.2827Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M252.312 66.0254C246.605 69.1526 237.359 69.1526 231.652 66.0254C229.051 64.6357 227.679 62.7594 227.39 60.952C227.101 63.246 228.474 65.5382 231.652 67.2758C237.359 70.403 246.605 70.403 252.312 67.2758C255.419 65.5382 256.864 63.2448 256.575 60.952C256.285 62.8282 254.914 64.6327 252.312 66.0254Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M253.842 78.5798C247.29 82.0979 236.674 82.0979 230.122 78.5798C227.136 77.0164 225.56 74.9056 225.228 72.8722C224.896 75.453 226.473 78.0317 230.122 79.9865C236.674 83.5046 247.29 83.5046 253.842 79.9865C257.41 78.0317 259.069 75.4516 258.737 72.8722C258.405 74.9829 256.83 77.0131 253.842 78.5798Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M257.695 60.952C267.271 60.952 275.034 68.9577 275.034 78.8323C275.034 88.7069 267.271 96.7126 257.695 96.7126C248.119 96.7126 240.357 88.7069 240.357 78.8323C240.357 68.9577 248.119 60.952 257.695 60.952Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M268.408 74.6946C262.49 77.8218 252.901 77.8218 246.983 74.6946C244.286 73.3049 242.863 71.4287 242.563 69.6212C242.263 71.9152 243.687 74.2075 246.983 75.945C252.901 79.0723 262.49 79.0723 268.408 75.945C271.63 74.2075 273.128 71.9141 272.829 69.6212C272.528 71.4974 271.106 73.302 268.408 74.6946Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M270.098 87.249C263.545 90.7671 252.93 90.7671 246.377 87.249C243.391 85.6856 241.815 83.5749 241.483 81.5414C241.151 84.1222 242.728 86.701 246.377 88.6557C252.93 92.1739 263.545 92.1739 270.098 88.6557C273.665 86.701 275.324 84.1209 274.992 81.5414C274.66 83.6522 273.085 85.6823 270.098 87.249Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M242.524 76.1232C249.107 76.1232 254.444 81.7029 254.444 88.5852C254.444 95.4675 249.107 101.047 242.524 101.047C235.94 101.047 230.604 95.4675 230.604 88.5852C230.604 81.7029 235.94 76.1232 242.524 76.1232Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M249.252 86.4302C245.236 88.7756 238.729 88.7756 234.713 86.4302C232.883 85.3879 231.917 83.9807 231.714 82.6251C231.51 84.3456 232.476 86.0648 234.713 87.368C238.729 89.7134 245.236 89.7134 249.252 87.368C251.438 86.0648 252.455 84.3448 252.251 82.6251C252.048 84.0323 251.083 85.3857 249.252 86.4302Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M250.941 95.0994C246.291 97.4448 238.757 97.4448 234.107 95.0994C231.988 94.0571 230.87 92.65 230.634 91.2944C230.399 93.0149 231.517 94.7341 234.107 96.0372C238.757 98.3827 246.291 98.3827 250.941 96.0372C253.473 94.7341 254.65 93.014 254.415 91.2944C254.179 92.7015 253.061 94.0549 250.941 95.0994Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 415",
    d: "M291.982 247.113L343.393 210.174L391.597 230.259L301.468 270.769L291.982 247.113Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Haus_Photo_Klein"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M230.897 216.592L255.04 230.164V199.297L230.897 185.723V216.592Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M255.038 199.297L232.372 186.173L233.564 185.577L256.231 198.701V229.57L255.038 230.166V199.297Z",
    fill: "#050A29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M234.087 215.922L235.222 215.221L254.07 225.988V227.554L234.087 215.922Z",
    fill: "#B6B3AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M234.088 215.921L235.205 215.252V189.378L234.16 188.708L234.088 215.921Z",
    fill: "#B6B3AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M214.024 223.826V163.282L298.806 212.195V272.739L288.293 266.699V219.577L268.236 208.019V255.142L214.024 223.826ZM229.006 186.396V218.905L252.951 232.85V200.339L229.006 186.396Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M288.591 219.501L269.95 208.764L270.547 208.539L289.112 219.278V263.568L288.591 263.792L288.591 219.501Z",
    fill: "#D5D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M273.305 232.773L273.902 233.072V252.756L287.025 260.066V260.588L273.379 252.983L273.305 232.773Z",
    fill: "#D5D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M273.305 213.164L273.902 213.463V230.535L287.025 238.065V238.586L273.381 230.757L273.305 213.164Z",
    fill: "#D5D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M270.995 253.577L270.025 253.055V208.765L288.666 219.503V263.792L276.587 256.858L283.372 260.734L270.995 253.577ZM273.38 252.979L287.026 260.585V240.527L273.457 232.773L273.38 252.979ZM273.38 213.163V230.831L286.876 238.66V220.994L273.38 213.163Z",
    fill: "#E7EBE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M288.666 219.95L264.582 206.155L265.103 205.932L289.113 219.651V267.296L288.666 267.52V219.95Z",
    fill: "#94ACB0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M266.968 255.141L268.534 254.396V211.449L266.968 210.704V255.141Z",
    fill: "#85879D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M268.46 253.801L270.026 252.831V212.414L268.46 211.444V253.801Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M258.542 260.212L275.99 270.2L287.845 263.34L270.472 253.353L258.542 260.212Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M275.916 270.201L287.846 263.348V264.02L275.916 270.879L258.542 260.891V260.212L275.916 270.201Z",
    fill: "#81959F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M264.581 206.155L288.666 219.95V267.518L285.762 265.879V265.735L285.835 221.445L267.047 210.708V255.146L264.661 253.803L264.581 206.155Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M342.201 244.853L316.031 259.915V208.76L343.705 192.304L342.201 244.853Z",
    fill: "#81959F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M316.03 208.765L342.201 193.783L341.008 193.112L314.838 208.095V259.243L316.03 259.914V208.765Z",
    fill: "#0E166B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M340.412 243.735L339.219 243.064L317 255.591V257.232L340.412 243.735Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M340.412 243.734L339.219 243.063V196.985L340.412 196.313V243.734Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M227.326 186.388V222.439L232.297 220.51L232.297 188.409L227.326 186.388Z",
    fill: "#B6B3AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M339.74 147.474L293.437 220.545L287.398 224.049L342.051 136.962L372.473 174.764L361.064 177.374L339.74 147.474Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M342.052 136.961L287.398 224.051L200.683 174.914L256.231 88.7214L342.052 136.961Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M229.017 218.98L232.372 217.042L253.026 228.972V232.92L229.017 218.98Z",
    fill: "#E7EBE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M361.065 177.376V237.323L344.437 246.499L343.761 193.213L316.923 208.244V262.301L298.806 272.74V212.196L339.74 147.476L361.065 177.376Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M344.438 246.493L342.202 244.928L342.202 194.09L344.513 192.748L344.438 246.493Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Photovoltaik"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M255.608 90.5563L282.423 106.026L232.109 187.205L204.484 171.221L255.608 90.5563Z",
    fill: "#D5C5E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M230.489 131.736L255.609 146.396L230.931 185.294L205.812 170.561L230.489 131.736Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M251.188 151.404L247.136 149.047C246.995 148.967 246.871 148.859 246.771 148.731C246.671 148.603 246.597 148.456 246.554 148.299C246.511 148.142 246.499 147.978 246.519 147.817C246.539 147.655 246.591 147.499 246.671 147.358C246.7 147.307 246.732 147.258 246.768 147.212L248.905 143.823C249.074 143.627 249.308 143.497 249.564 143.456C249.821 143.416 250.083 143.467 250.305 143.602L254.577 146.107C254.778 146.2 254.935 146.366 255.017 146.571C255.1 146.777 255.1 147.006 255.02 147.212L252.588 150.968C252.446 151.196 252.226 151.366 251.969 151.446C251.712 151.526 251.435 151.511 251.188 151.404Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M244.854 147.794L240.803 145.437C240.517 145.275 240.307 145.006 240.22 144.689C240.133 144.372 240.175 144.033 240.337 143.748C240.366 143.697 240.398 143.648 240.434 143.602L242.571 140.213C242.74 140.016 242.974 139.886 243.23 139.846C243.487 139.805 243.749 139.857 243.971 139.992L248.244 142.496C248.444 142.59 248.602 142.756 248.684 142.962C248.766 143.167 248.766 143.396 248.686 143.602L246.254 147.358C246.115 147.59 245.896 147.763 245.637 147.843C245.379 147.923 245.1 147.906 244.854 147.794Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M247.58 156.855L243.528 154.498C243.386 154.417 243.262 154.31 243.162 154.182C243.062 154.053 242.988 153.906 242.945 153.75C242.902 153.593 242.89 153.429 242.91 153.267C242.93 153.106 242.982 152.95 243.062 152.809C243.091 152.758 243.124 152.709 243.16 152.663L245.296 149.274C245.466 149.077 245.699 148.947 245.956 148.907C246.212 148.866 246.474 148.918 246.696 149.053L250.969 151.557C251.169 151.651 251.326 151.817 251.409 152.022C251.491 152.228 251.492 152.457 251.411 152.663L248.979 156.419C248.837 156.648 248.617 156.818 248.36 156.898C248.103 156.977 247.826 156.962 247.58 156.855Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M241.242 153.245L237.191 150.889C236.905 150.726 236.695 150.457 236.608 150.14C236.521 149.823 236.563 149.484 236.725 149.198C236.754 149.148 236.787 149.099 236.823 149.053L238.959 145.664C239.129 145.467 239.362 145.337 239.619 145.297C239.875 145.256 240.137 145.308 240.359 145.442L244.632 147.947C244.833 148.041 244.99 148.207 245.072 148.412C245.154 148.618 245.155 148.847 245.074 149.053L242.643 152.809C242.5 153.038 242.281 153.207 242.023 153.287C241.766 153.367 241.489 153.352 241.242 153.245Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M238.592 144.111L234.54 141.754C234.254 141.593 234.043 141.324 233.955 141.007C233.867 140.691 233.908 140.352 234.069 140.066C234.1 140.012 234.134 139.961 234.172 139.912L236.308 136.524C236.478 136.328 236.711 136.198 236.968 136.157C237.224 136.117 237.486 136.168 237.708 136.303L241.981 138.808C242.181 138.901 242.339 139.067 242.421 139.272C242.503 139.478 242.504 139.707 242.423 139.912L239.991 143.669C239.85 143.899 239.631 144.069 239.374 144.151C239.117 144.232 238.839 144.217 238.592 144.111Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M232.256 140.502L228.205 138.146C228.063 138.065 227.939 137.958 227.839 137.829C227.739 137.701 227.666 137.554 227.622 137.397C227.579 137.24 227.567 137.077 227.587 136.915C227.607 136.754 227.659 136.598 227.74 136.456C227.768 136.405 227.801 136.356 227.837 136.31L229.975 132.914C230.145 132.718 230.378 132.588 230.635 132.547C230.891 132.507 231.153 132.558 231.375 132.693L235.648 135.197C235.848 135.291 236.006 135.457 236.088 135.663C236.17 135.868 236.171 136.097 236.091 136.303L233.659 140.06C233.509 140.28 233.289 140.444 233.034 140.524C232.78 140.605 232.506 140.597 232.256 140.502Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M234.982 149.561L230.93 147.206C230.644 147.044 230.434 146.775 230.345 146.459C230.257 146.142 230.298 145.803 230.46 145.516C230.49 145.463 230.524 145.412 230.562 145.363L232.698 141.975C232.868 141.778 233.102 141.649 233.358 141.608C233.614 141.568 233.877 141.62 234.098 141.754L238.371 144.258C238.572 144.351 238.729 144.518 238.811 144.723C238.893 144.928 238.894 145.157 238.813 145.363L236.382 149.12C236.24 149.349 236.021 149.52 235.764 149.601C235.507 149.682 235.229 149.668 234.982 149.561Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M228.647 145.952L224.596 143.595C224.31 143.433 224.1 143.164 224.013 142.847C223.926 142.531 223.968 142.192 224.13 141.906C224.159 141.855 224.191 141.806 224.227 141.76L226.364 138.371C226.533 138.175 226.767 138.045 227.023 138.004C227.28 137.964 227.542 138.016 227.764 138.15L232.037 140.655C232.237 140.748 232.394 140.914 232.476 141.12C232.559 141.325 232.559 141.554 232.478 141.76L230.047 145.516C229.905 145.745 229.685 145.914 229.428 145.994C229.171 146.074 228.894 146.06 228.647 145.952Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M244.043 162.38L239.991 160.023C239.705 159.862 239.495 159.593 239.406 159.277C239.318 158.96 239.359 158.622 239.52 158.335C239.551 158.282 239.585 158.231 239.623 158.182L241.762 154.792C241.932 154.595 242.165 154.465 242.421 154.425C242.678 154.385 242.94 154.436 243.162 154.571L247.435 157.075C247.635 157.169 247.792 157.335 247.874 157.541C247.957 157.746 247.957 157.975 247.876 158.181L245.445 161.937C245.316 162.181 245.097 162.364 244.835 162.446C244.573 162.529 244.288 162.506 244.043 162.38Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M237.708 158.77L233.657 156.414C233.515 156.334 233.391 156.226 233.291 156.098C233.191 155.969 233.117 155.822 233.074 155.665C233.03 155.509 233.018 155.345 233.039 155.183C233.059 155.022 233.11 154.866 233.191 154.724C233.22 154.673 233.252 154.625 233.288 154.578L235.425 151.189C235.594 150.993 235.828 150.863 236.084 150.822C236.341 150.782 236.603 150.833 236.825 150.968L241.098 153.473C241.298 153.566 241.455 153.733 241.538 153.938C241.62 154.143 241.62 154.372 241.539 154.578L239.108 158.335C238.969 158.567 238.749 158.739 238.491 158.82C238.233 158.9 237.954 158.882 237.708 158.77Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M240.507 167.978L236.455 165.622C236.313 165.542 236.189 165.435 236.088 165.306C235.988 165.178 235.914 165.032 235.87 164.875C235.826 164.718 235.814 164.554 235.834 164.393C235.853 164.231 235.905 164.075 235.985 163.933C236.015 163.88 236.049 163.828 236.087 163.78L238.223 160.391C238.393 160.195 238.627 160.065 238.883 160.025C239.139 159.984 239.402 160.036 239.623 160.17L243.896 162.675C244.097 162.768 244.254 162.935 244.336 163.14C244.418 163.345 244.419 163.574 244.338 163.78L241.907 167.536C241.769 167.769 241.55 167.943 241.291 168.025C241.033 168.106 240.754 168.09 240.507 167.978Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M234.173 164.368L230.121 162.012C229.979 161.931 229.855 161.824 229.755 161.695C229.655 161.567 229.581 161.42 229.538 161.263C229.495 161.107 229.483 160.943 229.503 160.781C229.523 160.62 229.575 160.464 229.655 160.322C229.684 160.271 229.717 160.223 229.752 160.176L231.889 156.787C232.059 156.591 232.292 156.461 232.549 156.42C232.805 156.38 233.067 156.432 233.289 156.566L237.562 159.071C237.762 159.164 237.92 159.33 238.002 159.536C238.084 159.741 238.084 159.97 238.003 160.176L235.572 163.932C235.446 164.175 235.228 164.358 234.967 164.441C234.706 164.523 234.423 164.499 234.18 164.372L234.173 164.368Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M231.446 155.087L227.395 152.73C227.253 152.65 227.129 152.542 227.029 152.414C226.929 152.286 226.855 152.139 226.812 151.982C226.768 151.825 226.757 151.661 226.777 151.5C226.797 151.338 226.848 151.182 226.929 151.041C226.958 150.99 226.991 150.941 227.026 150.894L229.163 147.506C229.333 147.31 229.566 147.179 229.822 147.139C230.079 147.098 230.341 147.15 230.563 147.285L234.836 149.79C235.036 149.883 235.194 150.049 235.276 150.254C235.358 150.46 235.358 150.689 235.277 150.894L232.846 154.651C232.716 154.892 232.497 155.073 232.235 155.155C231.973 155.236 231.69 155.212 231.446 155.087Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M225.112 151.478L221.06 149.121C220.919 149.04 220.795 148.933 220.695 148.804C220.595 148.676 220.521 148.529 220.478 148.372C220.434 148.215 220.423 148.052 220.443 147.89C220.463 147.729 220.515 147.573 220.595 147.431C220.624 147.38 220.656 147.331 220.692 147.285L222.829 143.896C222.998 143.7 223.231 143.57 223.488 143.529C223.744 143.488 224.006 143.54 224.228 143.675L228.501 146.179C228.702 146.273 228.859 146.439 228.941 146.645C229.023 146.85 229.024 147.079 228.943 147.285L226.512 151.042C226.373 151.273 226.153 151.446 225.895 151.526C225.637 151.607 225.358 151.589 225.112 151.478Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M227.837 160.686L223.785 158.329C223.643 158.249 223.518 158.142 223.418 158.014C223.318 157.885 223.244 157.739 223.2 157.582C223.156 157.425 223.144 157.262 223.164 157.1C223.183 156.938 223.235 156.782 223.315 156.641C223.344 156.587 223.379 156.536 223.417 156.487L225.556 153.097C225.725 152.901 225.959 152.771 226.215 152.731C226.471 152.69 226.734 152.742 226.955 152.877L231.228 155.381C231.429 155.475 231.586 155.641 231.668 155.846C231.75 156.052 231.751 156.281 231.67 156.487L229.239 160.243C229.085 160.46 228.865 160.62 228.612 160.7C228.359 160.78 228.087 160.775 227.837 160.686Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M221.501 157.075L217.45 154.719C217.308 154.639 217.184 154.531 217.084 154.403C216.984 154.274 216.91 154.128 216.867 153.971C216.824 153.814 216.812 153.65 216.832 153.488C216.852 153.327 216.903 153.171 216.984 153.029C217.013 152.978 217.046 152.929 217.081 152.883L219.218 149.494C219.388 149.298 219.621 149.168 219.878 149.128C220.134 149.087 220.396 149.139 220.618 149.273L224.891 151.778C225.091 151.871 225.249 152.037 225.331 152.243C225.413 152.448 225.413 152.677 225.332 152.883L222.901 156.639C222.75 156.858 222.53 157.02 222.276 157.099C222.023 157.178 221.75 157.17 221.501 157.075Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M237.119 173.503L233.067 171.147C232.781 170.985 232.57 170.717 232.482 170.4C232.394 170.083 232.435 169.745 232.596 169.458C232.627 169.405 232.661 169.353 232.699 169.305L234.835 165.916C235.005 165.72 235.238 165.59 235.495 165.55C235.751 165.509 236.013 165.561 236.235 165.695L240.508 168.199C240.708 168.293 240.866 168.459 240.948 168.665C241.03 168.87 241.031 169.099 240.95 169.305L238.518 173.062C238.39 173.304 238.171 173.486 237.909 173.569C237.647 173.651 237.363 173.628 237.119 173.503Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M230.783 169.894L226.732 167.537C226.59 167.457 226.465 167.35 226.365 167.221C226.265 167.093 226.191 166.947 226.147 166.79C226.103 166.633 226.091 166.469 226.11 166.308C226.13 166.146 226.181 165.99 226.261 165.849C226.291 165.795 226.326 165.744 226.364 165.695L228.502 162.305C228.672 162.109 228.906 161.979 229.162 161.939C229.418 161.899 229.68 161.95 229.902 162.085L234.175 164.589C234.376 164.683 234.533 164.849 234.615 165.054C234.697 165.26 234.698 165.489 234.617 165.695L232.186 169.451C232.047 169.684 231.828 169.859 231.569 169.94C231.31 170.022 231.031 170.005 230.783 169.894Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M233.508 178.954L229.456 176.599C229.17 176.437 228.96 176.168 228.872 175.852C228.783 175.535 228.825 175.196 228.986 174.91C229.017 174.857 229.051 174.805 229.088 174.756L231.224 171.368C231.394 171.172 231.627 171.042 231.884 171.002C232.14 170.961 232.402 171.013 232.624 171.147L236.897 173.652C237.097 173.745 237.255 173.911 237.337 174.116C237.419 174.322 237.42 174.55 237.339 174.756L234.908 178.513C234.779 178.755 234.56 178.937 234.298 179.02C234.036 179.103 233.752 179.079 233.508 178.954Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M227.174 175.345L223.122 172.988C222.836 172.826 222.626 172.557 222.539 172.24C222.452 171.923 222.494 171.585 222.656 171.299C222.685 171.248 222.718 171.199 222.754 171.152L224.89 167.764C225.06 167.567 225.293 167.437 225.549 167.397C225.806 167.356 226.068 167.408 226.29 167.543L230.563 170.047C230.763 170.14 230.92 170.307 231.003 170.512C231.085 170.717 231.085 170.946 231.004 171.152L228.573 174.909C228.431 175.137 228.211 175.307 227.954 175.387C227.697 175.467 227.42 175.452 227.174 175.345Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M224.522 166.21L220.47 163.853C220.329 163.773 220.204 163.666 220.104 163.538C220.003 163.41 219.929 163.264 219.885 163.107C219.842 162.95 219.829 162.786 219.849 162.625C219.868 162.463 219.92 162.307 220 162.165C220.03 162.112 220.064 162.06 220.102 162.011L222.238 158.623C222.408 158.427 222.641 158.297 222.898 158.256C223.154 158.216 223.416 158.267 223.638 158.402L227.911 160.906C228.112 161 228.269 161.166 228.351 161.371C228.433 161.577 228.434 161.806 228.353 162.011L225.922 165.768C225.78 165.998 225.561 166.168 225.304 166.25C225.047 166.331 224.769 166.317 224.522 166.21Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M218.187 162.601L214.135 160.245C213.849 160.082 213.639 159.813 213.552 159.497C213.465 159.18 213.507 158.842 213.669 158.556C213.698 158.505 213.73 158.456 213.766 158.409L215.903 155.021C216.073 154.825 216.306 154.695 216.562 154.654C216.819 154.614 217.081 154.665 217.303 154.8L221.576 157.305C221.776 157.398 221.933 157.564 222.016 157.769C222.098 157.974 222.098 158.203 222.017 158.409L219.586 162.165C219.447 162.397 219.228 162.57 218.97 162.65C218.711 162.731 218.433 162.713 218.187 162.601Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M220.913 171.662L216.861 169.305C216.576 169.143 216.366 168.873 216.279 168.557C216.191 168.24 216.233 167.901 216.396 167.615C216.425 167.564 216.457 167.516 216.493 167.469L218.63 164.081C218.799 163.884 219.033 163.754 219.289 163.714C219.545 163.673 219.808 163.725 220.029 163.86L224.302 166.364C224.503 166.457 224.66 166.624 224.742 166.829C224.824 167.034 224.825 167.263 224.744 167.469L222.313 171.226C222.171 171.454 221.951 171.624 221.694 171.704C221.437 171.784 221.16 171.769 220.913 171.662Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M214.577 168.052L210.525 165.695C210.383 165.615 210.259 165.508 210.158 165.38C210.058 165.252 209.984 165.106 209.94 164.949C209.896 164.792 209.884 164.628 209.904 164.467C209.923 164.305 209.975 164.149 210.055 164.007C210.085 163.954 210.119 163.902 210.157 163.853L212.296 160.464C212.465 160.268 212.699 160.138 212.955 160.097C213.211 160.057 213.473 160.108 213.695 160.243L217.968 162.747C218.169 162.84 218.326 163.006 218.408 163.212C218.49 163.417 218.491 163.646 218.41 163.852L215.979 167.609C215.837 167.839 215.618 168.011 215.36 168.092C215.103 168.173 214.825 168.159 214.577 168.052Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M229.826 184.48L225.774 182.124C225.489 181.961 225.279 181.692 225.192 181.375C225.105 181.058 225.147 180.72 225.309 180.434C225.338 180.383 225.37 180.334 225.406 180.287L227.543 176.899C227.712 176.703 227.946 176.572 228.202 176.532C228.459 176.492 228.721 176.543 228.943 176.678L233.215 179.183C233.416 179.276 233.573 179.442 233.655 179.647C233.737 179.853 233.738 180.082 233.657 180.287L231.226 184.044C231.087 184.276 230.867 184.449 230.609 184.529C230.351 184.609 230.072 184.592 229.826 184.48Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M223.563 180.87L219.512 178.513C219.37 178.433 219.246 178.326 219.145 178.198C219.045 178.07 218.971 177.923 218.927 177.766C218.883 177.609 218.871 177.446 218.891 177.284C218.91 177.123 218.962 176.967 219.042 176.825C219.072 176.771 219.106 176.72 219.144 176.671L221.28 173.283C221.449 173.086 221.683 172.956 221.939 172.916C222.196 172.875 222.458 172.927 222.68 173.061L226.952 175.566C227.153 175.659 227.31 175.825 227.392 176.031C227.475 176.236 227.475 176.465 227.394 176.671L224.963 180.428C224.821 180.657 224.602 180.828 224.345 180.909C224.088 180.991 223.811 180.976 223.563 180.87Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M217.23 177.186L213.178 174.83C212.892 174.668 212.682 174.4 212.593 174.083C212.505 173.766 212.546 173.427 212.707 173.141C212.738 173.088 212.772 173.037 212.81 172.988L214.947 169.599C215.116 169.403 215.35 169.273 215.606 169.233C215.862 169.192 216.125 169.244 216.346 169.378L220.619 171.883C220.82 171.976 220.977 172.142 221.059 172.348C221.141 172.553 221.142 172.782 221.061 172.988L218.63 176.744C218.492 176.977 218.272 177.151 218.014 177.233C217.756 177.314 217.476 177.298 217.23 177.186Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M210.968 173.576L206.916 171.219C206.63 171.057 206.421 170.788 206.333 170.471C206.246 170.155 206.288 169.816 206.45 169.53C206.479 169.479 206.512 169.431 206.548 169.384L208.684 165.995C208.854 165.799 209.087 165.669 209.344 165.628C209.6 165.588 209.862 165.64 210.084 165.774L214.357 168.279C214.557 168.372 214.715 168.539 214.797 168.744C214.879 168.95 214.879 169.179 214.798 169.384L212.367 173.141C212.225 173.369 212.006 173.539 211.749 173.619C211.492 173.699 211.214 173.684 210.968 173.576Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M232.477 133.061L208.316 171.882L232.477 133.061Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M232.477 133.061L208.316 171.882L232.477 133.061Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M234.025 134.019L209.862 172.84L234.025 134.019Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M234.025 134.019L209.862 172.84L234.025 134.019Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M238.666 136.744L214.503 175.565L238.666 136.744Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M238.666 136.744L214.503 175.565L238.666 136.744Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M240.213 137.776L216.05 176.596L240.213 137.776Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M240.213 137.776L216.05 176.596L240.213 137.776Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M244.854 140.354L220.691 179.176L244.854 140.354Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M244.854 140.354L220.691 179.176L244.854 140.354Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M246.474 141.385L222.312 180.206L246.474 141.385Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M246.474 141.385L222.312 180.206L246.474 141.385Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M251.116 143.965L226.954 182.785L251.116 143.965Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M251.116 143.965L226.954 182.785L251.116 143.965Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M252.663 144.995L228.5 183.816L252.663 144.995Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M252.663 144.995L228.5 183.816L252.663 144.995Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M230.414 131.662L230.342 131.736L255.609 146.395L255.682 146.321L230.414 131.662Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M230.342 131.736L230.268 131.81L255.461 146.469V146.322L230.342 131.736Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M255.609 146.394L255.682 146.321L231.226 185.363L230.93 185.51L255.609 146.394Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M255.609 146.394L255.463 146.321L230.785 185.436L230.93 185.51L255.609 146.394Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M230.416 131.956L230.563 132.029L205.811 170.698L205.59 170.771L230.416 131.956Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M230.489 131.81L230.343 131.663L205.443 170.632L205.589 170.779L230.489 131.81Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M205.812 170.557H205.665L230.858 185.359V185.212L205.812 170.557Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M205.664 170.557L205.591 170.778L230.783 185.438L230.857 185.365L205.664 170.557Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M282.423 106.026L283.307 107.278L232.993 188.456L232.11 187.204L282.423 106.026Z",
    fill: "#3D3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M232.11 187.205L232.993 188.457L205.738 172.546L204.486 171.219L232.11 187.205Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M255.535 92.251L280.581 106.911L255.903 145.732L230.858 130.998L255.535 92.251Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M276.161 111.919L272.109 109.563C271.823 109.401 271.613 109.133 271.524 108.816C271.436 108.499 271.477 108.161 271.638 107.874C271.669 107.821 271.703 107.769 271.741 107.721L273.877 104.332C274.047 104.136 274.28 104.006 274.537 103.966C274.793 103.925 275.055 103.977 275.277 104.111L279.55 106.616C279.751 106.709 279.908 106.876 279.99 107.081C280.072 107.286 280.073 107.515 279.992 107.721L277.561 111.477C277.411 111.697 277.191 111.861 276.937 111.941C276.683 112.021 276.41 112.013 276.161 111.919Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M269.899 108.236L265.848 105.878C265.707 105.798 265.582 105.691 265.482 105.562C265.382 105.434 265.308 105.287 265.265 105.13C265.222 104.973 265.21 104.809 265.23 104.648C265.25 104.486 265.302 104.33 265.382 104.189C265.411 104.138 265.444 104.089 265.479 104.043L267.616 100.654C267.785 100.457 268.019 100.327 268.276 100.287C268.532 100.246 268.794 100.298 269.016 100.433L273.289 102.937C273.49 103.031 273.647 103.197 273.729 103.403C273.811 103.608 273.812 103.837 273.731 104.043L271.3 107.799C271.157 108.028 270.938 108.198 270.681 108.278C270.424 108.358 270.146 108.343 269.899 108.236Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M272.551 117.371L268.499 115.014C268.358 114.934 268.234 114.827 268.133 114.698C268.033 114.57 267.96 114.423 267.916 114.266C267.873 114.109 267.861 113.945 267.881 113.784C267.901 113.622 267.953 113.466 268.034 113.324C268.062 113.273 268.095 113.225 268.131 113.179L270.267 109.79C270.437 109.593 270.67 109.463 270.927 109.423C271.183 109.382 271.446 109.434 271.667 109.569L275.94 112.073C276.141 112.167 276.298 112.333 276.38 112.538C276.462 112.744 276.463 112.973 276.382 113.179L273.951 116.935C273.8 117.154 273.58 117.316 273.326 117.395C273.072 117.474 272.799 117.466 272.551 117.371Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M266.218 113.688L262.166 111.331C261.88 111.169 261.671 110.9 261.583 110.583C261.496 110.266 261.538 109.927 261.701 109.641C261.729 109.59 261.762 109.542 261.798 109.496L263.934 106.106C264.104 105.91 264.338 105.78 264.594 105.739C264.85 105.699 265.113 105.751 265.335 105.885L269.607 108.39C269.807 108.483 269.965 108.65 270.047 108.855C270.129 109.061 270.13 109.29 270.049 109.496L267.617 113.252C267.491 113.495 267.273 113.678 267.012 113.76C266.751 113.843 266.468 113.818 266.225 113.692L266.218 113.688Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M263.565 104.553L259.513 102.196C259.372 102.116 259.247 102.008 259.147 101.88C259.047 101.752 258.974 101.605 258.93 101.448C258.887 101.291 258.875 101.127 258.895 100.966C258.915 100.804 258.967 100.648 259.047 100.507C259.076 100.456 259.109 100.407 259.145 100.36L261.281 96.9718C261.451 96.7752 261.684 96.645 261.941 96.6045C262.197 96.5639 262.459 96.6154 262.681 96.7501L266.954 99.2553C267.155 99.3487 267.312 99.515 267.394 99.7203C267.476 99.9256 267.477 100.154 267.396 100.36L264.965 104.117C264.838 104.36 264.621 104.543 264.36 104.625C264.098 104.708 263.815 104.683 263.572 104.557L263.565 104.553Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M257.303 100.944L253.251 98.5866C253.11 98.5067 252.985 98.3996 252.885 98.2715C252.784 98.1435 252.71 97.9968 252.666 97.8401C252.623 97.6834 252.61 97.5195 252.63 97.358C252.649 97.1964 252.7 97.0403 252.78 96.8986C252.811 96.845 252.845 96.7938 252.883 96.7453L255.022 93.3556C255.191 93.1592 255.425 93.0291 255.681 92.9886C255.937 92.948 256.199 92.9995 256.421 93.1339L260.695 95.6391C260.895 95.7325 261.052 95.8988 261.134 96.1041C261.216 96.3094 261.217 96.5383 261.136 96.7441L258.705 100.501C258.563 100.731 258.344 100.902 258.086 100.984C257.829 101.065 257.55 101.051 257.303 100.944Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M259.956 110.004L255.904 107.647C255.762 107.567 255.638 107.46 255.538 107.331C255.438 107.203 255.364 107.056 255.321 106.899C255.278 106.742 255.266 106.579 255.286 106.417C255.306 106.256 255.358 106.1 255.438 105.958C255.467 105.907 255.5 105.858 255.536 105.812L257.672 102.423C257.842 102.227 258.075 102.097 258.332 102.056C258.588 102.016 258.85 102.068 259.072 102.202L263.345 104.707C263.546 104.8 263.703 104.967 263.785 105.172C263.867 105.377 263.868 105.606 263.787 105.812L261.356 109.568C261.229 109.811 261.012 109.994 260.75 110.077C260.489 110.159 260.206 110.135 259.963 110.008L259.956 110.004Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M253.62 106.395L249.569 104.038C249.283 103.875 249.073 103.606 248.986 103.289C248.899 102.972 248.941 102.634 249.103 102.348C249.132 102.297 249.164 102.248 249.2 102.202L251.339 98.8063C251.508 98.61 251.742 98.48 251.998 98.4395C252.255 98.3991 252.517 98.4507 252.739 98.5852L257.011 101.09C257.212 101.183 257.369 101.349 257.452 101.555C257.534 101.76 257.535 101.989 257.454 102.195L255.022 105.951C254.884 106.185 254.665 106.36 254.406 106.441C254.147 106.523 253.867 106.507 253.62 106.395Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M269.016 122.895L264.965 120.539C264.823 120.459 264.699 120.351 264.599 120.223C264.499 120.094 264.425 119.948 264.381 119.791C264.338 119.634 264.326 119.47 264.346 119.308C264.367 119.147 264.418 118.991 264.499 118.849C264.527 118.798 264.56 118.75 264.596 118.703L266.732 115.314C266.902 115.118 267.136 114.988 267.392 114.947C267.648 114.907 267.911 114.959 268.133 115.093L272.405 117.598C272.606 117.691 272.763 117.858 272.845 118.063C272.927 118.269 272.928 118.498 272.847 118.703L270.416 122.46C270.277 122.692 270.057 122.864 269.799 122.945C269.541 123.025 269.262 123.008 269.016 122.895Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M262.755 119.212L258.703 116.856C258.562 116.775 258.437 116.668 258.337 116.539C258.237 116.411 258.164 116.264 258.12 116.107C258.077 115.95 258.065 115.787 258.086 115.625C258.106 115.464 258.157 115.308 258.238 115.166C258.267 115.115 258.299 115.067 258.335 115.021L260.471 111.632C260.641 111.436 260.875 111.306 261.131 111.265C261.387 111.225 261.65 111.276 261.872 111.411L266.144 113.915C266.344 114.008 266.502 114.175 266.584 114.38C266.666 114.586 266.667 114.815 266.586 115.021L264.154 118.777C264.012 119.006 263.793 119.175 263.536 119.255C263.279 119.335 263.002 119.32 262.755 119.212Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M265.552 128.42L261.501 126.065C261.215 125.903 261.004 125.634 260.916 125.318C260.828 125.001 260.869 124.662 261.03 124.376C261.06 124.322 261.094 124.271 261.132 124.222L263.269 120.834C263.438 120.637 263.672 120.507 263.928 120.467C264.185 120.427 264.447 120.478 264.669 120.613L268.942 123.117C269.142 123.21 269.299 123.377 269.381 123.582C269.463 123.787 269.464 124.016 269.383 124.222L266.952 127.979C266.823 128.221 266.604 128.403 266.343 128.486C266.081 128.569 265.797 128.545 265.552 128.42Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M259.218 124.884L255.166 122.527C255.025 122.447 254.9 122.34 254.8 122.212C254.699 122.084 254.625 121.938 254.581 121.781C254.538 121.624 254.525 121.46 254.545 121.299C254.564 121.137 254.616 120.981 254.695 120.839C254.726 120.786 254.76 120.735 254.798 120.686L256.934 117.298C257.104 117.101 257.337 116.971 257.594 116.931C257.85 116.89 258.112 116.942 258.334 117.077L262.607 119.581C262.808 119.674 262.965 119.841 263.047 120.046C263.129 120.251 263.13 120.48 263.049 120.686L260.618 124.443C260.464 124.659 260.245 124.819 259.992 124.899C259.739 124.978 259.467 124.973 259.218 124.884Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M256.421 115.603L252.369 113.246C252.228 113.166 252.103 113.059 252.003 112.93C251.903 112.802 251.83 112.655 251.786 112.498C251.743 112.341 251.731 112.177 251.751 112.016C251.771 111.854 251.823 111.698 251.904 111.557C251.932 111.506 251.965 111.457 252.001 111.411L254.137 108.022C254.307 107.825 254.541 107.696 254.797 107.655C255.053 107.615 255.315 107.666 255.537 107.801L259.81 110.305C260.011 110.399 260.168 110.565 260.25 110.771C260.332 110.976 260.333 111.205 260.252 111.411L257.821 115.167C257.67 115.386 257.45 115.547 257.196 115.627C256.942 115.706 256.669 115.698 256.421 115.603Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M250.158 111.919L246.106 109.563C245.82 109.401 245.61 109.133 245.522 108.816C245.433 108.499 245.475 108.16 245.636 107.874C245.666 107.821 245.7 107.769 245.738 107.721L247.875 104.333C248.044 104.136 248.278 104.006 248.534 103.966C248.791 103.925 249.053 103.977 249.275 104.111L253.547 106.616C253.748 106.709 253.905 106.876 253.987 107.081C254.069 107.286 254.07 107.515 253.989 107.721L251.558 111.478C251.416 111.707 251.197 111.878 250.94 111.959C250.683 112.04 250.406 112.026 250.158 111.919Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M252.81 121.128L248.758 118.77C248.617 118.69 248.492 118.582 248.392 118.454C248.292 118.325 248.219 118.179 248.175 118.022C248.132 117.865 248.12 117.701 248.14 117.539C248.16 117.378 248.212 117.222 248.293 117.08C248.321 117.029 248.354 116.981 248.39 116.934L250.526 113.545C250.696 113.349 250.929 113.219 251.186 113.178C251.442 113.138 251.705 113.189 251.926 113.324L256.199 115.829C256.4 115.922 256.557 116.089 256.639 116.294C256.721 116.5 256.722 116.729 256.641 116.934L254.21 120.691C254.071 120.923 253.851 121.096 253.593 121.176C253.335 121.257 253.056 121.24 252.81 121.128Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M246.547 117.518L242.496 115.159C242.354 115.079 242.23 114.972 242.13 114.843C242.03 114.715 241.956 114.568 241.913 114.411C241.87 114.254 241.858 114.09 241.878 113.929C241.898 113.767 241.95 113.612 242.03 113.47C242.059 113.419 242.092 113.37 242.128 113.324L244.264 109.935C244.434 109.739 244.667 109.609 244.924 109.568C245.18 109.528 245.442 109.579 245.664 109.714L249.937 112.219C250.137 112.312 250.294 112.478 250.377 112.684C250.459 112.889 250.459 113.118 250.379 113.324L247.947 117.08C247.805 117.309 247.585 117.479 247.329 117.559C247.072 117.639 246.794 117.625 246.547 117.518Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M262.091 134.019L258.039 131.662C257.898 131.582 257.773 131.474 257.673 131.346C257.574 131.217 257.5 131.071 257.457 130.914C257.413 130.757 257.402 130.593 257.422 130.432C257.442 130.27 257.494 130.114 257.574 129.973C257.603 129.922 257.635 129.873 257.671 129.826L259.808 126.437C259.977 126.241 260.211 126.111 260.467 126.07C260.724 126.03 260.986 126.081 261.208 126.216L265.481 128.721C265.681 128.814 265.838 128.981 265.92 129.186C266.002 129.392 266.003 129.62 265.922 129.826L263.491 133.583C263.34 133.802 263.12 133.963 262.866 134.042C262.613 134.121 262.34 134.113 262.091 134.019Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M255.829 130.337L251.779 127.98C251.637 127.899 251.513 127.792 251.413 127.663C251.312 127.535 251.239 127.388 251.195 127.231C251.152 127.074 251.14 126.91 251.16 126.749C251.18 126.587 251.232 126.431 251.313 126.29C251.341 126.239 251.374 126.19 251.41 126.144L253.548 122.748C253.718 122.552 253.952 122.422 254.208 122.382C254.464 122.341 254.726 122.393 254.948 122.527L259.221 125.031C259.421 125.125 259.579 125.291 259.661 125.496C259.743 125.702 259.744 125.931 259.664 126.136L257.232 129.893C257.09 130.123 256.871 130.295 256.613 130.376C256.356 130.458 256.077 130.444 255.829 130.337Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M258.481 139.471L254.43 137.113C254.276 137.025 254.143 136.905 254.039 136.762C253.935 136.618 253.864 136.453 253.829 136.279C253.794 136.105 253.796 135.926 253.837 135.753C253.877 135.581 253.953 135.418 254.061 135.278L256.198 131.889C256.368 131.693 256.601 131.563 256.858 131.523C257.114 131.482 257.376 131.534 257.598 131.669L261.871 134.173C262.072 134.267 262.229 134.433 262.311 134.638C262.393 134.843 262.394 135.072 262.313 135.278L259.882 139.034C259.731 139.253 259.511 139.415 259.257 139.494C259.003 139.573 258.73 139.565 258.481 139.471Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M252.146 135.787L248.095 133.43C247.809 133.268 247.6 132.999 247.512 132.682C247.425 132.365 247.467 132.026 247.63 131.74C247.658 131.689 247.691 131.641 247.727 131.595L249.865 128.199C250.035 128.003 250.269 127.873 250.525 127.832C250.781 127.792 251.043 127.843 251.265 127.978L255.538 130.482C255.738 130.575 255.896 130.742 255.978 130.947C256.06 131.152 256.061 131.381 255.98 131.587L253.549 135.344C253.487 135.464 253.402 135.572 253.299 135.66C253.196 135.748 253.076 135.815 252.947 135.856C252.818 135.898 252.682 135.914 252.547 135.903C252.412 135.893 252.28 135.855 252.159 135.793L252.146 135.787Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M249.495 126.652L245.444 124.296C245.157 124.134 244.947 123.865 244.858 123.549C244.77 123.232 244.811 122.893 244.973 122.607C245.003 122.554 245.037 122.502 245.075 122.454L247.211 119.065C247.381 118.869 247.615 118.739 247.871 118.699C248.127 118.658 248.39 118.71 248.611 118.844L252.884 121.348C253.085 121.442 253.242 121.608 253.324 121.814C253.406 122.019 253.407 122.248 253.326 122.454L250.895 126.21C250.77 126.454 250.553 126.638 250.292 126.722C250.031 126.805 249.748 126.782 249.504 126.657L249.495 126.652Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M243.233 123.043L239.181 120.686C239.039 120.606 238.915 120.499 238.815 120.37C238.715 120.242 238.642 120.095 238.598 119.938C238.555 119.781 238.543 119.617 238.563 119.456C238.583 119.294 238.635 119.139 238.716 118.997C238.744 118.946 238.777 118.897 238.813 118.851L240.949 115.462C241.119 115.265 241.352 115.135 241.609 115.095C241.865 115.054 242.128 115.106 242.349 115.24L246.622 117.745C246.823 117.839 246.98 118.005 247.062 118.21C247.144 118.416 247.145 118.645 247.064 118.851L244.633 122.607C244.49 122.836 244.271 123.005 244.014 123.085C243.757 123.165 243.48 123.15 243.233 123.043Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M245.885 132.103L241.834 129.747C241.692 129.667 241.568 129.559 241.468 129.431C241.368 129.302 241.294 129.156 241.251 128.999C241.208 128.842 241.196 128.678 241.216 128.516C241.236 128.355 241.288 128.199 241.368 128.057C241.397 128.006 241.429 127.957 241.465 127.911L243.602 124.522C243.771 124.326 244.005 124.196 244.261 124.155C244.518 124.115 244.78 124.166 245.002 124.301L249.275 126.806C249.475 126.899 249.633 127.066 249.715 127.271C249.797 127.477 249.797 127.706 249.716 127.911L247.285 131.668C247.159 131.911 246.941 132.093 246.68 132.176C246.419 132.258 246.136 132.234 245.893 132.108L245.885 132.103Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M239.55 128.494L235.498 126.137C235.356 126.057 235.232 125.949 235.132 125.821C235.032 125.692 234.959 125.546 234.915 125.389C234.872 125.232 234.86 125.068 234.88 124.907C234.9 124.745 234.952 124.589 235.033 124.448C235.061 124.397 235.094 124.348 235.13 124.301L237.266 120.913C237.436 120.716 237.669 120.586 237.926 120.546C238.182 120.505 238.444 120.557 238.666 120.692L242.939 123.196C243.139 123.289 243.297 123.456 243.379 123.661C243.461 123.866 243.462 124.095 243.381 124.301L240.95 128.058C240.824 128.301 240.606 128.484 240.345 128.566C240.083 128.649 239.8 128.624 239.557 128.498L239.55 128.494Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M254.872 144.922L250.821 142.565C250.679 142.485 250.555 142.378 250.455 142.249C250.355 142.121 250.281 141.974 250.238 141.817C250.194 141.66 250.182 141.496 250.203 141.335C250.223 141.173 250.274 141.017 250.355 140.876C250.383 140.825 250.416 140.776 250.452 140.73L252.588 137.341C252.758 137.145 252.992 137.015 253.248 136.975C253.504 136.934 253.767 136.986 253.989 137.12L258.262 139.625C258.462 139.718 258.619 139.885 258.701 140.09C258.783 140.295 258.784 140.524 258.703 140.73L256.272 144.486C256.142 144.728 255.922 144.908 255.661 144.99C255.399 145.071 255.116 145.047 254.872 144.922Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M248.536 141.312L244.485 138.955C244.199 138.793 243.989 138.524 243.902 138.207C243.815 137.89 243.857 137.551 244.019 137.265C244.048 137.214 244.08 137.166 244.116 137.12L246.253 133.731C246.423 133.534 246.656 133.404 246.913 133.364C247.169 133.324 247.431 133.375 247.653 133.509L251.926 136.014C252.127 136.108 252.284 136.274 252.366 136.479C252.448 136.685 252.449 136.914 252.368 137.12L249.937 140.876C249.797 141.108 249.578 141.281 249.32 141.361C249.061 141.441 248.783 141.424 248.536 141.312Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M242.276 137.629L238.224 135.273C237.938 135.111 237.728 134.842 237.639 134.526C237.551 134.209 237.592 133.87 237.753 133.584C237.784 133.53 237.818 133.479 237.856 133.43L239.993 130.042C240.162 129.846 240.396 129.716 240.652 129.675C240.909 129.635 241.171 129.687 241.393 129.821L245.665 132.325C245.866 132.418 246.023 132.585 246.105 132.79C246.187 132.995 246.188 133.224 246.107 133.43L243.676 137.187C243.535 137.416 243.315 137.587 243.058 137.668C242.801 137.749 242.524 137.735 242.276 137.629Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M235.94 134.02L231.888 131.663C231.747 131.582 231.623 131.475 231.522 131.347C231.422 131.218 231.349 131.071 231.305 130.915C231.262 130.758 231.25 130.594 231.27 130.432C231.29 130.271 231.342 130.115 231.423 129.973C231.452 129.922 231.484 129.874 231.52 129.827L233.659 126.431C233.828 126.235 234.062 126.105 234.318 126.064C234.575 126.024 234.837 126.075 235.059 126.21L239.332 128.715C239.532 128.808 239.69 128.974 239.772 129.18C239.854 129.385 239.854 129.614 239.773 129.82L237.342 133.577C237.204 133.81 236.985 133.985 236.726 134.066C236.467 134.148 236.187 134.131 235.94 134.02Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M257.451 93.5032L233.288 132.325L257.451 93.5032Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M257.451 93.5032L233.288 132.325L257.451 93.5032Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M258.997 94.5347L234.836 133.356L258.997 94.5347Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M258.997 94.5347L234.836 133.356L258.997 94.5347Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M263.639 97.2598L239.476 136.081L263.639 97.2598Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M263.639 97.2598L239.476 136.081L263.639 97.2598Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M265.259 98.2184L241.096 137.04L265.259 98.2184Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M265.259 98.2184L241.096 137.04L265.259 98.2184Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M269.9 100.869L245.737 139.691L269.9 100.869Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M269.9 100.869L245.737 139.691L269.9 100.869Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M271.447 101.827L247.285 140.648L271.447 101.827Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M271.447 101.827L247.285 140.648L271.447 101.827Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M276.087 104.479L251.925 143.3L276.087 104.479Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M276.087 104.479L251.925 143.3L276.087 104.479Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M277.635 105.436L253.472 144.258L277.635 105.436Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M277.635 105.436L253.472 144.258L277.635 105.436Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M255.461 92.1035L255.314 92.177L280.582 106.906L280.729 106.832L255.461 92.1035Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M255.314 92.1763V92.3233L280.434 106.91V106.836L255.314 92.1763Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M280.582 106.909L280.729 106.837L256.198 145.805L255.903 145.952L280.582 106.909Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M280.582 106.909L280.509 106.837L255.831 145.952H255.904L280.582 106.909Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M255.462 92.3982L255.536 92.4717L230.784 131.146L230.638 131.22L255.462 92.3982Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M255.535 92.2504L255.313 92.1769L230.414 131.075L230.636 131.222L255.535 92.2504Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M230.858 130.999H230.711L255.83 145.801L255.904 145.654L230.858 130.999Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M230.709 130.999L230.636 131.22L255.829 145.953V145.801L230.709 130.999Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M283.823 106.689L310.637 122.232L260.324 203.338L232.699 187.354L283.823 106.689Z",
    fill: "#D5C5E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M258.704 147.868L283.823 162.601L259.146 201.423L234.026 186.689L258.704 147.868Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M279.402 167.537L275.352 165.181C275.21 165.101 275.086 164.993 274.986 164.865C274.886 164.736 274.812 164.589 274.769 164.432C274.725 164.276 274.713 164.112 274.733 163.95C274.754 163.789 274.805 163.633 274.886 163.491C274.914 163.44 274.947 163.391 274.983 163.345L277.121 159.949C277.291 159.753 277.524 159.623 277.781 159.582C278.037 159.542 278.3 159.593 278.521 159.728L282.794 162.233C282.994 162.326 283.152 162.492 283.234 162.698C283.316 162.903 283.317 163.132 283.237 163.338L280.805 167.094C280.676 167.337 280.457 167.52 280.194 167.603C279.932 167.686 279.647 167.662 279.402 167.537Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M273.067 163.927L269.016 161.57C268.874 161.49 268.749 161.383 268.649 161.255C268.549 161.127 268.474 160.98 268.431 160.823C268.387 160.667 268.375 160.503 268.394 160.341C268.414 160.18 268.465 160.024 268.545 159.882C268.575 159.828 268.609 159.777 268.647 159.728L270.784 156.34C270.954 156.143 271.187 156.013 271.444 155.973C271.7 155.932 271.962 155.984 272.184 156.118L276.456 158.623C276.657 158.716 276.814 158.883 276.896 159.088C276.979 159.293 276.979 159.522 276.899 159.728L274.468 163.485C274.329 163.718 274.11 163.892 273.852 163.973C273.594 164.055 273.314 164.038 273.067 163.927Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M275.794 172.988L271.742 170.632C271.456 170.469 271.247 170.2 271.159 169.883C271.072 169.566 271.114 169.228 271.277 168.942C271.305 168.891 271.338 168.842 271.374 168.796L273.51 165.407C273.68 165.21 273.914 165.08 274.17 165.04C274.426 164.999 274.689 165.051 274.91 165.186L279.183 167.69C279.383 167.784 279.541 167.95 279.623 168.156C279.705 168.361 279.706 168.59 279.625 168.796L277.194 172.552C277.064 172.793 276.845 172.974 276.583 173.056C276.321 173.137 276.038 173.113 275.794 172.988Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M269.457 169.378L265.406 167.02C265.265 166.94 265.14 166.832 265.04 166.704C264.94 166.576 264.866 166.429 264.823 166.272C264.78 166.115 264.768 165.951 264.788 165.79C264.808 165.628 264.86 165.472 264.94 165.331C264.969 165.28 265.001 165.231 265.037 165.184L267.174 161.796C267.343 161.599 267.577 161.469 267.833 161.429C268.09 161.388 268.352 161.44 268.574 161.575L272.847 164.079C273.047 164.173 273.205 164.339 273.287 164.544C273.369 164.75 273.369 164.979 273.289 165.184L270.858 168.941C270.728 169.182 270.508 169.363 270.247 169.445C269.985 169.527 269.702 169.503 269.457 169.378Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M266.806 160.243L262.755 157.887C262.468 157.725 262.258 157.457 262.17 157.14C262.081 156.823 262.122 156.484 262.284 156.198C262.314 156.145 262.348 156.093 262.386 156.045L264.522 152.656C264.692 152.46 264.926 152.33 265.182 152.29C265.438 152.249 265.701 152.301 265.923 152.435L270.196 154.94C270.396 155.033 270.553 155.2 270.635 155.405C270.717 155.61 270.718 155.839 270.637 156.045L268.206 159.801C268.065 160.031 267.845 160.202 267.588 160.283C267.331 160.364 267.053 160.35 266.806 160.243Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M260.471 156.635L256.42 154.278C256.278 154.198 256.154 154.09 256.054 153.962C255.954 153.834 255.88 153.687 255.837 153.53C255.793 153.373 255.781 153.21 255.802 153.048C255.822 152.887 255.873 152.731 255.954 152.589C255.982 152.538 256.015 152.489 256.051 152.442L258.187 149.055C258.357 148.858 258.591 148.728 258.847 148.688C259.103 148.647 259.366 148.699 259.588 148.833L263.861 151.338C264.061 151.431 264.218 151.597 264.3 151.803C264.382 152.008 264.383 152.237 264.302 152.442L261.871 156.199C261.732 156.431 261.512 156.604 261.254 156.684C260.996 156.764 260.717 156.747 260.471 156.635Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M263.196 165.695L259.145 163.338C259.003 163.258 258.879 163.151 258.778 163.023C258.678 162.895 258.604 162.749 258.56 162.592C258.516 162.435 258.504 162.271 258.523 162.11C258.543 161.948 258.594 161.792 258.674 161.65C258.704 161.597 258.738 161.545 258.776 161.496L260.915 158.107C261.085 157.91 261.318 157.78 261.575 157.74C261.831 157.699 262.093 157.751 262.315 157.886L266.588 160.39C266.788 160.484 266.946 160.65 267.028 160.855C267.11 161.061 267.111 161.29 267.03 161.496L264.598 165.252C264.47 165.495 264.25 165.678 263.988 165.761C263.726 165.844 263.441 165.82 263.196 165.695Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M256.861 162.085L252.809 159.728C252.667 159.648 252.543 159.541 252.442 159.413C252.342 159.285 252.268 159.138 252.224 158.982C252.181 158.825 252.168 158.661 252.188 158.499C252.208 158.338 252.259 158.182 252.339 158.04C252.369 157.987 252.403 157.935 252.441 157.887L254.577 154.498C254.747 154.301 254.981 154.171 255.237 154.131C255.493 154.09 255.756 154.142 255.978 154.277L260.251 156.781C260.451 156.875 260.608 157.041 260.69 157.247C260.772 157.452 260.773 157.681 260.692 157.887L258.261 161.643C258.12 161.873 257.9 162.044 257.643 162.125C257.386 162.206 257.108 162.192 256.861 162.085Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M272.258 178.586L268.206 176.228C268.065 176.148 267.94 176.041 267.84 175.912C267.74 175.784 267.667 175.637 267.623 175.48C267.58 175.323 267.568 175.159 267.588 174.998C267.608 174.836 267.66 174.68 267.74 174.539C267.769 174.488 267.802 174.439 267.838 174.393L269.974 171.004C270.144 170.808 270.377 170.678 270.634 170.637C270.89 170.597 271.152 170.648 271.374 170.783L275.647 173.288C275.848 173.381 276.005 173.547 276.087 173.753C276.169 173.958 276.17 174.187 276.089 174.393L273.658 178.149C273.504 178.364 273.284 178.524 273.031 178.603C272.778 178.681 272.507 178.676 272.258 178.586Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M265.922 174.903L261.871 172.546C261.729 172.466 261.605 172.359 261.504 172.231C261.404 172.103 261.33 171.957 261.286 171.8C261.242 171.643 261.23 171.479 261.249 171.318C261.269 171.156 261.32 171 261.4 170.858C261.43 170.804 261.464 170.753 261.502 170.704L263.639 167.316C263.808 167.12 264.042 166.99 264.298 166.949C264.555 166.909 264.817 166.96 265.039 167.095L269.312 169.599C269.512 169.693 269.67 169.859 269.752 170.064C269.834 170.27 269.834 170.499 269.754 170.704L267.323 174.461C267.184 174.694 266.965 174.868 266.707 174.949C266.449 175.031 266.169 175.014 265.922 174.903Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M268.721 184.111L264.669 181.754C264.528 181.674 264.404 181.567 264.304 181.438C264.204 181.31 264.13 181.163 264.087 181.006C264.044 180.849 264.032 180.686 264.052 180.524C264.072 180.363 264.124 180.207 264.204 180.065C264.233 180.014 264.265 179.965 264.301 179.919L266.438 176.53C266.607 176.334 266.841 176.204 267.097 176.163C267.354 176.123 267.616 176.174 267.838 176.309L272.111 178.813C272.311 178.907 272.468 179.073 272.551 179.279C272.633 179.484 272.633 179.713 272.552 179.919L270.121 183.675C269.982 183.907 269.763 184.08 269.504 184.16C269.246 184.241 268.967 184.223 268.721 184.111Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M262.387 180.501L258.335 178.145C258.049 177.982 257.839 177.713 257.752 177.396C257.665 177.079 257.707 176.741 257.869 176.455C257.898 176.404 257.931 176.355 257.967 176.309L260.103 172.92C260.273 172.724 260.506 172.594 260.763 172.553C261.019 172.513 261.282 172.564 261.503 172.699L265.776 175.204C265.976 175.297 266.133 175.463 266.216 175.668C266.298 175.874 266.299 176.103 266.218 176.309L263.786 180.065C263.724 180.185 263.638 180.292 263.534 180.38C263.43 180.467 263.31 180.533 263.181 180.574C263.052 180.614 262.915 180.629 262.78 180.618C262.645 180.606 262.514 180.567 262.393 180.505L262.387 180.501Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M259.661 171.22L255.61 168.863C255.468 168.783 255.344 168.676 255.244 168.547C255.144 168.419 255.07 168.272 255.027 168.115C254.983 167.958 254.971 167.794 254.991 167.633C255.012 167.471 255.063 167.315 255.144 167.173C255.173 167.123 255.205 167.074 255.241 167.028L257.377 163.639C257.547 163.442 257.781 163.312 258.037 163.272C258.293 163.231 258.556 163.283 258.778 163.417L263.051 165.922C263.251 166.016 263.408 166.182 263.49 166.387C263.572 166.593 263.573 166.822 263.492 167.028L261.061 170.784C260.934 171.027 260.717 171.21 260.456 171.292C260.195 171.375 259.911 171.35 259.668 171.224L259.661 171.22Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M253.4 167.61L249.348 165.253C249.206 165.173 249.082 165.065 248.982 164.937C248.882 164.809 248.808 164.662 248.765 164.505C248.722 164.348 248.71 164.184 248.73 164.023C248.75 163.861 248.802 163.705 248.882 163.564C248.911 163.513 248.944 163.464 248.98 163.418L251.116 160.029C251.286 159.833 251.519 159.702 251.776 159.662C252.032 159.622 252.294 159.673 252.516 159.808L256.789 162.312C256.989 162.405 257.146 162.572 257.229 162.777C257.311 162.983 257.312 163.212 257.231 163.418L254.799 167.174C254.657 167.402 254.437 167.572 254.18 167.652C253.923 167.732 253.646 167.717 253.4 167.61Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M256.051 176.819L252 174.462C251.858 174.382 251.734 174.274 251.634 174.146C251.534 174.018 251.46 173.871 251.417 173.714C251.373 173.557 251.361 173.393 251.381 173.232C251.402 173.07 251.453 172.914 251.534 172.773C251.563 172.722 251.595 172.673 251.631 172.626L253.767 169.238C253.937 169.041 254.171 168.911 254.427 168.871C254.683 168.83 254.946 168.882 255.168 169.017L259.44 171.521C259.641 171.615 259.798 171.781 259.88 171.986C259.962 172.192 259.963 172.42 259.882 172.626L257.451 176.383C257.312 176.615 257.092 176.787 256.834 176.868C256.576 176.948 256.297 176.931 256.051 176.819Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M249.716 173.21L245.665 170.853C245.379 170.692 245.168 170.423 245.08 170.107C244.992 169.79 245.033 169.451 245.194 169.165C245.224 169.111 245.258 169.06 245.296 169.012L247.433 165.623C247.602 165.427 247.836 165.297 248.092 165.256C248.349 165.216 248.611 165.268 248.833 165.402L253.106 167.907C253.306 168 253.463 168.166 253.546 168.372C253.628 168.577 253.628 168.806 253.547 169.012L251.116 172.768C250.978 173.001 250.759 173.175 250.501 173.256C250.242 173.338 249.963 173.321 249.716 173.21Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M265.332 189.636L261.281 187.28C260.995 187.118 260.785 186.848 260.698 186.531C260.611 186.215 260.653 185.876 260.815 185.59C260.844 185.539 260.876 185.49 260.913 185.444L263.049 182.055C263.219 181.859 263.452 181.729 263.709 181.689C263.965 181.648 264.227 181.7 264.449 181.834L268.722 184.339C268.923 184.432 269.08 184.599 269.162 184.804C269.244 185.01 269.245 185.238 269.164 185.444L266.733 189.201C266.603 189.442 266.383 189.623 266.121 189.704C265.86 189.786 265.576 189.761 265.332 189.636Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M258.998 186.027L254.946 183.67C254.805 183.589 254.68 183.482 254.58 183.354C254.48 183.225 254.407 183.078 254.364 182.922C254.32 182.765 254.308 182.601 254.329 182.439C254.349 182.278 254.4 182.122 254.481 181.981C254.51 181.929 254.542 181.88 254.578 181.834L256.714 178.446C256.884 178.249 257.118 178.119 257.374 178.079C257.63 178.038 257.893 178.09 258.115 178.225L262.387 180.729C262.588 180.822 262.745 180.989 262.827 181.194C262.909 181.399 262.91 181.628 262.829 181.834L260.398 185.591C260.259 185.823 260.039 185.995 259.781 186.076C259.523 186.156 259.244 186.139 258.998 186.027Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M261.722 195.161L257.67 192.805C257.384 192.643 257.174 192.375 257.086 192.058C256.997 191.741 257.039 191.403 257.2 191.116C257.23 191.063 257.264 191.011 257.302 190.963L259.441 187.573C259.611 187.377 259.844 187.247 260.101 187.206C260.357 187.166 260.619 187.218 260.841 187.352L265.114 189.857C265.314 189.95 265.472 190.116 265.554 190.322C265.636 190.527 265.637 190.756 265.556 190.962L263.124 194.718C262.971 194.935 262.751 195.096 262.498 195.176C262.245 195.256 261.972 195.251 261.722 195.161Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M255.388 191.478L251.336 189.121C251.194 189.04 251.07 188.933 250.97 188.804C250.87 188.676 250.796 188.529 250.753 188.372C250.71 188.215 250.698 188.052 250.718 187.89C250.738 187.729 250.79 187.573 250.87 187.431C250.899 187.38 250.932 187.331 250.968 187.285L253.104 183.897C253.274 183.701 253.507 183.571 253.764 183.53C254.02 183.49 254.282 183.541 254.504 183.676L258.777 186.181C258.977 186.274 259.134 186.44 259.217 186.645C259.299 186.85 259.3 187.079 259.219 187.285L256.787 191.042C256.657 191.283 256.438 191.464 256.176 191.545C255.915 191.627 255.632 191.602 255.388 191.478Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M252.737 182.343L248.685 179.986C248.544 179.906 248.419 179.799 248.319 179.671C248.218 179.543 248.144 179.396 248.1 179.24C248.057 179.083 248.044 178.919 248.064 178.757C248.084 178.596 248.135 178.44 248.215 178.298C248.245 178.244 248.279 178.193 248.317 178.145L250.454 174.756C250.623 174.559 250.857 174.43 251.113 174.389C251.37 174.349 251.632 174.4 251.854 174.535L256.126 177.039C256.327 177.133 256.484 177.299 256.566 177.505C256.648 177.71 256.649 177.939 256.568 178.145L254.137 181.901C254.008 182.143 253.789 182.325 253.527 182.408C253.266 182.491 252.982 182.468 252.737 182.343Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M246.401 178.735L242.349 176.378C242.063 176.217 241.853 175.948 241.764 175.631C241.676 175.315 241.717 174.976 241.879 174.69C241.909 174.636 241.943 174.585 241.981 174.536L244.117 171.148C244.287 170.952 244.521 170.822 244.777 170.781C245.033 170.741 245.296 170.792 245.518 170.927L249.79 173.431C249.99 173.524 250.148 173.691 250.23 173.896C250.312 174.101 250.313 174.33 250.232 174.536L247.801 178.293C247.662 178.526 247.443 178.7 247.185 178.781C246.927 178.863 246.648 178.846 246.401 178.735Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M249.126 187.795L245.075 185.437C244.934 185.357 244.809 185.249 244.709 185.121C244.609 184.993 244.535 184.846 244.492 184.689C244.449 184.532 244.437 184.368 244.457 184.207C244.477 184.045 244.529 183.889 244.609 183.748C244.638 183.697 244.67 183.648 244.706 183.601L246.843 180.213C247.012 180.016 247.246 179.886 247.502 179.846C247.759 179.805 248.021 179.857 248.243 179.992L252.516 182.496C252.716 182.59 252.874 182.756 252.956 182.961C253.038 183.167 253.038 183.395 252.958 183.601L250.527 187.358C250.397 187.599 250.177 187.78 249.916 187.862C249.654 187.944 249.371 187.92 249.126 187.795Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M242.791 184.185L238.739 181.829C238.453 181.667 238.243 181.398 238.154 181.082C238.066 180.765 238.107 180.426 238.268 180.14C238.299 180.086 238.333 180.035 238.371 179.987L240.508 176.598C240.677 176.402 240.911 176.272 241.167 176.231C241.424 176.191 241.686 176.243 241.908 176.377L246.18 178.882C246.381 178.975 246.538 179.141 246.62 179.347C246.702 179.552 246.703 179.781 246.622 179.987L244.191 183.743C244.05 183.973 243.83 184.144 243.573 184.225C243.316 184.306 243.039 184.292 242.791 184.185Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M258.039 200.613L253.988 198.256C253.846 198.176 253.722 198.068 253.622 197.94C253.522 197.812 253.448 197.665 253.405 197.508C253.362 197.351 253.35 197.187 253.37 197.025C253.39 196.864 253.442 196.708 253.522 196.566C253.551 196.515 253.583 196.467 253.619 196.421L255.758 193.025C255.927 192.828 256.161 192.698 256.417 192.658C256.673 192.617 256.936 192.669 257.158 192.804L261.431 195.308C261.632 195.402 261.789 195.568 261.871 195.773C261.953 195.978 261.954 196.207 261.873 196.413L259.441 200.17C259.303 200.403 259.084 200.578 258.825 200.66C258.566 200.741 258.286 200.725 258.039 200.613Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M251.778 197.003L247.726 194.646C247.584 194.566 247.46 194.458 247.36 194.33C247.26 194.202 247.186 194.055 247.143 193.898C247.1 193.741 247.088 193.577 247.108 193.416C247.128 193.254 247.18 193.098 247.26 192.957C247.289 192.906 247.322 192.857 247.358 192.81L249.494 189.422C249.664 189.225 249.897 189.095 250.154 189.055C250.41 189.014 250.672 189.066 250.894 189.201L255.167 191.705C255.367 191.799 255.524 191.965 255.607 192.17C255.689 192.376 255.69 192.605 255.609 192.81L253.177 196.567C253.035 196.795 252.815 196.965 252.558 197.045C252.301 197.125 252.024 197.11 251.778 197.003Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M245.516 193.319L241.465 190.963C241.324 190.883 241.199 190.775 241.099 190.647C240.999 190.518 240.925 190.371 240.882 190.214C240.839 190.058 240.827 189.894 240.847 189.732C240.867 189.571 240.919 189.415 240.999 189.273C241.028 189.222 241.06 189.173 241.096 189.127L243.235 185.731C243.404 185.534 243.638 185.404 243.894 185.364C244.151 185.323 244.413 185.375 244.635 185.51L248.907 188.014C249.108 188.108 249.265 188.274 249.348 188.48C249.43 188.685 249.431 188.914 249.35 189.12L246.918 192.877C246.777 193.107 246.557 193.278 246.299 193.36C246.042 193.441 245.764 193.426 245.516 193.319Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M239.181 189.71L235.13 187.353C234.989 187.273 234.864 187.166 234.764 187.037C234.664 186.909 234.59 186.762 234.547 186.605C234.504 186.448 234.492 186.284 234.512 186.123C234.532 185.961 234.584 185.805 234.664 185.663C234.693 185.613 234.726 185.564 234.761 185.517L236.899 182.129C237.068 181.932 237.302 181.803 237.558 181.762C237.814 181.722 238.076 181.773 238.298 181.908L242.571 184.412C242.772 184.505 242.929 184.672 243.011 184.877C243.093 185.082 243.094 185.311 243.013 185.517L240.582 189.274C240.439 189.502 240.22 189.672 239.963 189.752C239.706 189.832 239.428 189.817 239.181 189.71Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M260.692 149.193L236.53 188.015L260.692 149.193Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M260.692 149.193L236.53 188.015L260.692 149.193Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M262.239 150.151L238.077 188.972L262.239 150.151Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M262.239 150.151L238.077 188.972L262.239 150.151Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M266.88 152.952L242.718 191.773L266.88 152.952Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M266.88 152.952L242.718 191.773L266.88 152.952Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M268.427 153.909L244.264 192.729L268.427 153.909Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M268.427 153.909L244.264 192.729L268.427 153.909Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M273.069 156.56L248.906 195.382L273.069 156.56Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M273.069 156.56L248.906 195.382L273.069 156.56Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M274.689 157.518L250.526 196.34L274.689 157.518Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M274.689 157.518L250.526 196.34L274.689 157.518Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M279.33 160.17L255.167 198.991L279.33 160.17Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M279.33 160.17L255.167 198.991L279.33 160.17Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M280.877 161.129L256.714 199.949L280.877 161.129Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M280.877 161.129L256.714 199.949L280.877 161.129Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M258.703 147.795L258.556 147.869L283.824 162.597L283.971 162.524L258.703 147.795Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M258.556 147.868L258.482 148.015L283.676 162.601V162.527L258.556 147.868Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M283.824 162.602L283.971 162.529L259.44 201.498L259.145 201.644L283.824 162.602Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M283.823 162.602L283.676 162.529L259.072 201.571L259.145 201.644L283.823 162.602Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M258.704 148.088L258.777 148.162L234.026 186.836L233.88 186.91L258.704 148.088Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M258.703 147.942L258.557 147.868L233.657 186.767L233.88 186.913L258.703 147.942Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M234.026 186.689H233.88L259.072 201.491L259.146 201.344L234.026 186.689Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M233.879 186.689V186.91L259.072 201.57V201.491L233.879 186.689Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M310.638 122.233L311.521 123.411L261.207 204.59L260.324 203.338L310.638 122.233Z",
    fill: "#3D3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M260.324 203.338L261.207 204.59L233.951 188.678L232.699 187.351L260.324 203.338Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M283.75 108.384L308.796 123.044L284.192 161.865L259.073 147.132L283.75 108.384Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M304.375 128.052L300.323 125.696C300.037 125.534 299.828 125.264 299.741 124.947C299.653 124.63 299.696 124.292 299.858 124.006C299.886 123.955 299.919 123.906 299.955 123.86L302.092 120.471C302.261 120.275 302.495 120.145 302.751 120.104C303.007 120.064 303.27 120.115 303.492 120.25L307.764 122.754C307.965 122.848 308.122 123.014 308.204 123.219C308.286 123.425 308.287 123.654 308.206 123.86L305.775 127.616C305.624 127.835 305.404 127.997 305.15 128.076C304.896 128.155 304.623 128.147 304.375 128.052Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M298.113 124.369L294.061 122.013C293.775 121.851 293.565 121.583 293.476 121.266C293.388 120.949 293.429 120.61 293.591 120.324C293.621 120.27 293.655 120.219 293.693 120.171L295.83 116.782C295.999 116.586 296.233 116.456 296.489 116.416C296.746 116.375 297.008 116.427 297.23 116.562L301.502 119.066C301.703 119.159 301.86 119.325 301.942 119.53C302.024 119.736 302.025 119.965 301.944 120.171L299.513 123.927C299.372 124.157 299.153 124.327 298.895 124.409C298.638 124.49 298.361 124.475 298.113 124.369Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M300.766 133.504L296.714 131.147C296.572 131.067 296.448 130.96 296.347 130.832C296.247 130.704 296.173 130.557 296.129 130.4C296.086 130.243 296.073 130.08 296.093 129.918C296.113 129.757 296.164 129.6 296.244 129.459C296.274 129.405 296.308 129.353 296.346 129.305L298.484 125.842C298.654 125.645 298.888 125.515 299.144 125.475C299.4 125.434 299.663 125.486 299.884 125.621L304.157 128.125C304.358 128.219 304.515 128.385 304.597 128.59C304.679 128.796 304.68 129.025 304.599 129.231L302.168 132.987C302.049 133.241 301.835 133.437 301.573 133.534C301.311 133.63 301.02 133.619 300.766 133.504Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M294.43 129.894L290.379 127.537C290.238 127.457 290.113 127.349 290.013 127.221C289.913 127.093 289.839 126.946 289.796 126.789C289.753 126.632 289.741 126.468 289.761 126.307C289.781 126.145 289.833 125.989 289.913 125.848C289.942 125.797 289.975 125.748 290.01 125.702L292.147 122.312C292.317 122.116 292.55 121.986 292.807 121.946C293.063 121.905 293.325 121.957 293.547 122.092L297.82 124.596C298.021 124.69 298.178 124.856 298.26 125.062C298.342 125.267 298.343 125.496 298.262 125.702L295.831 129.457C295.68 129.676 295.46 129.838 295.206 129.917C294.952 129.997 294.679 129.988 294.43 129.894Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M291.779 120.759L287.727 118.402C287.585 118.322 287.461 118.214 287.361 118.086C287.261 117.958 287.187 117.811 287.144 117.654C287.101 117.497 287.089 117.333 287.109 117.172C287.129 117.01 287.181 116.854 287.261 116.713C287.29 116.662 287.323 116.613 287.359 116.566L289.495 113.178C289.665 112.982 289.898 112.852 290.155 112.811C290.411 112.771 290.674 112.823 290.895 112.958L295.168 115.462C295.368 115.555 295.525 115.721 295.608 115.926C295.69 116.132 295.691 116.361 295.61 116.566L293.178 120.323C293.027 120.542 292.807 120.704 292.554 120.783C292.3 120.862 292.027 120.854 291.779 120.759Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M285.517 117.077L281.465 114.72C281.324 114.639 281.199 114.532 281.099 114.403C280.999 114.275 280.926 114.128 280.883 113.971C280.839 113.815 280.827 113.651 280.848 113.489C280.868 113.328 280.919 113.172 281 113.03C281.028 112.979 281.061 112.93 281.097 112.884L283.233 109.496C283.403 109.299 283.637 109.169 283.893 109.128C284.149 109.087 284.412 109.139 284.634 109.274L288.906 111.778C289.107 111.872 289.264 112.038 289.346 112.244C289.428 112.449 289.429 112.678 289.348 112.884L286.917 116.641C286.775 116.869 286.555 117.039 286.298 117.119C286.041 117.199 285.764 117.184 285.517 117.077Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M288.169 126.211L284.117 123.853C283.832 123.691 283.622 123.421 283.535 123.104C283.447 122.787 283.49 122.449 283.652 122.163C283.681 122.112 283.713 122.063 283.749 122.017L285.886 118.629C286.055 118.432 286.289 118.302 286.545 118.262C286.801 118.221 287.064 118.273 287.286 118.407L291.558 120.912C291.759 121.005 291.916 121.171 291.998 121.377C292.08 121.582 292.081 121.811 292 122.017L289.569 125.773C289.418 125.992 289.198 126.154 288.944 126.234C288.691 126.313 288.418 126.305 288.169 126.211Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M281.834 122.527L277.782 120.17C277.641 120.09 277.516 119.983 277.416 119.854C277.316 119.726 277.243 119.579 277.199 119.422C277.156 119.266 277.144 119.102 277.164 118.94C277.184 118.779 277.236 118.623 277.317 118.481C277.345 118.43 277.378 118.381 277.414 118.335L279.55 114.946C279.72 114.75 279.953 114.62 280.21 114.579C280.466 114.539 280.729 114.59 280.95 114.725L285.223 117.23C285.424 117.323 285.581 117.49 285.663 117.695C285.745 117.9 285.746 118.129 285.665 118.335L283.234 122.091C283.107 122.334 282.89 122.517 282.629 122.6C282.367 122.682 282.084 122.657 281.841 122.531L281.834 122.527Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M297.229 139.029L293.178 136.672C292.892 136.51 292.682 136.241 292.595 135.924C292.508 135.607 292.55 135.268 292.712 134.982C292.741 134.932 292.774 134.883 292.809 134.837L294.946 131.448C295.115 131.251 295.349 131.121 295.606 131.081C295.862 131.04 296.124 131.092 296.346 131.226L300.619 133.731C300.819 133.825 300.976 133.991 301.058 134.196C301.141 134.402 301.141 134.631 301.061 134.837L298.63 138.593C298.49 138.825 298.271 138.998 298.013 139.078C297.754 139.158 297.476 139.141 297.229 139.029Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M290.969 135.345L286.917 132.989C286.631 132.828 286.421 132.559 286.332 132.242C286.244 131.926 286.285 131.587 286.447 131.3C286.477 131.247 286.511 131.195 286.549 131.147L288.685 127.759C288.855 127.562 289.088 127.432 289.345 127.392C289.601 127.351 289.864 127.403 290.085 127.538L294.358 130.042C294.559 130.136 294.716 130.302 294.798 130.507C294.88 130.712 294.881 130.941 294.8 131.147L292.369 134.903C292.24 135.146 292.021 135.328 291.759 135.41C291.497 135.493 291.213 135.469 290.969 135.345Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M293.767 144.627L289.716 142.271C289.43 142.108 289.22 141.839 289.133 141.522C289.046 141.205 289.088 140.867 289.25 140.581C289.279 140.53 289.312 140.481 289.348 140.434L291.484 137.046C291.654 136.849 291.887 136.719 292.144 136.679C292.4 136.638 292.662 136.69 292.884 136.825L297.157 139.329C297.357 139.423 297.514 139.589 297.597 139.794C297.679 140 297.679 140.228 297.599 140.434L295.168 144.191C295.013 144.406 294.793 144.565 294.541 144.644C294.288 144.722 294.017 144.716 293.767 144.627Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M287.431 141.017L283.38 138.66C283.094 138.497 282.884 138.228 282.797 137.911C282.71 137.594 282.752 137.256 282.914 136.97C282.943 136.919 282.976 136.87 283.011 136.824L285.148 133.436C285.317 133.239 285.551 133.109 285.808 133.069C286.064 133.028 286.326 133.08 286.548 133.215L290.82 135.719C291.021 135.813 291.178 135.979 291.26 136.184C291.343 136.389 291.343 136.618 291.263 136.824L288.831 140.581C288.689 140.809 288.469 140.979 288.212 141.059C287.955 141.139 287.678 141.124 287.431 141.017Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M284.707 131.735L280.655 129.378C280.514 129.298 280.389 129.191 280.289 129.063C280.188 128.935 280.114 128.789 280.07 128.632C280.027 128.475 280.014 128.311 280.034 128.15C280.053 127.988 280.105 127.832 280.185 127.69C280.215 127.637 280.249 127.585 280.287 127.537L282.423 124.148C282.593 123.952 282.827 123.822 283.083 123.781C283.339 123.741 283.602 123.792 283.823 123.927L288.096 126.431C288.297 126.525 288.454 126.691 288.536 126.897C288.618 127.102 288.619 127.331 288.538 127.537L286.107 131.294C285.965 131.523 285.746 131.694 285.489 131.775C285.232 131.856 284.954 131.842 284.707 131.735Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M278.372 128.052L274.321 125.695C274.179 125.615 274.055 125.508 273.955 125.379C273.855 125.251 273.781 125.104 273.738 124.947C273.694 124.79 273.683 124.626 273.703 124.465C273.723 124.303 273.774 124.148 273.855 124.006C273.884 123.955 273.916 123.906 273.952 123.86L276.089 120.471C276.258 120.275 276.492 120.144 276.748 120.104C277.004 120.063 277.267 120.115 277.489 120.249L281.762 122.754C281.962 122.848 282.119 123.014 282.201 123.219C282.283 123.425 282.284 123.654 282.203 123.86L279.772 127.616C279.633 127.848 279.413 128.021 279.155 128.101C278.897 128.181 278.618 128.164 278.372 128.052Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M281.024 137.261L276.972 134.904C276.831 134.824 276.706 134.716 276.606 134.588C276.506 134.459 276.433 134.312 276.39 134.156C276.346 133.999 276.334 133.835 276.355 133.673C276.375 133.512 276.426 133.356 276.507 133.215C276.535 133.163 276.568 133.114 276.604 133.068L278.74 129.679C278.91 129.483 279.144 129.353 279.4 129.313C279.656 129.272 279.919 129.324 280.141 129.458L284.413 131.963C284.613 132.056 284.771 132.223 284.853 132.428C284.935 132.633 284.936 132.862 284.855 133.068L282.424 136.825C282.289 137.06 282.069 137.236 281.809 137.317C281.55 137.398 281.269 137.378 281.024 137.261Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M274.762 133.65L270.711 131.294C270.425 131.133 270.214 130.864 270.126 130.548C270.038 130.231 270.079 129.892 270.24 129.606C270.271 129.552 270.305 129.501 270.342 129.452L272.479 126.064C272.648 125.868 272.882 125.738 273.139 125.697C273.395 125.657 273.657 125.708 273.879 125.843L278.152 128.347C278.352 128.44 278.51 128.607 278.592 128.812C278.674 129.017 278.675 129.246 278.594 129.452L276.163 133.209C276.021 133.438 275.802 133.609 275.545 133.69C275.288 133.771 275.01 133.757 274.762 133.65Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M290.305 150.152L286.254 147.795C286.112 147.715 285.987 147.608 285.887 147.48C285.786 147.352 285.712 147.205 285.668 147.049C285.625 146.892 285.612 146.728 285.632 146.566C285.652 146.405 285.703 146.249 285.783 146.107C285.813 146.053 285.847 146.002 285.885 145.954L288.021 142.565C288.191 142.369 288.425 142.239 288.681 142.198C288.937 142.158 289.2 142.209 289.422 142.344L293.695 144.848C293.895 144.942 294.052 145.108 294.134 145.314C294.216 145.519 294.217 145.748 294.136 145.954L291.705 149.71C291.567 149.943 291.348 150.117 291.089 150.199C290.831 150.28 290.552 150.263 290.305 150.152Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M284.044 146.469L279.992 144.111C279.851 144.03 279.726 143.923 279.626 143.795C279.526 143.666 279.453 143.519 279.41 143.362C279.366 143.206 279.355 143.042 279.375 142.88C279.395 142.719 279.446 142.563 279.527 142.421C279.555 142.37 279.588 142.321 279.624 142.275L281.761 138.887C281.93 138.69 282.164 138.56 282.42 138.52C282.676 138.479 282.939 138.531 283.161 138.666L287.433 141.17C287.634 141.263 287.791 141.43 287.873 141.635C287.955 141.84 287.956 142.069 287.875 142.275L285.444 146.032C285.314 146.273 285.095 146.454 284.833 146.536C284.572 146.618 284.288 146.594 284.044 146.469Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M286.696 155.604L282.644 153.245C282.358 153.083 282.148 152.814 282.061 152.497C281.974 152.18 282.016 151.841 282.178 151.555C282.207 151.504 282.24 151.455 282.276 151.409L284.412 148.021C284.581 147.825 284.815 147.695 285.071 147.654C285.328 147.613 285.59 147.665 285.812 147.8L290.085 150.304C290.285 150.397 290.442 150.564 290.525 150.769C290.607 150.974 290.608 151.203 290.527 151.409L288.095 155.166C287.956 155.398 287.737 155.571 287.479 155.652C287.221 155.733 286.942 155.715 286.696 155.604Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M280.36 151.994L276.309 149.637C276.167 149.557 276.043 149.449 275.943 149.321C275.843 149.192 275.769 149.045 275.726 148.888C275.682 148.732 275.671 148.568 275.691 148.406C275.711 148.245 275.762 148.089 275.843 147.947C275.872 147.896 275.904 147.848 275.94 147.801L278.077 144.412C278.246 144.216 278.48 144.086 278.736 144.045C278.993 144.005 279.255 144.056 279.477 144.191L283.75 146.696C283.95 146.789 284.107 146.956 284.189 147.161C284.271 147.366 284.272 147.595 284.191 147.801L281.76 151.558C281.609 151.777 281.389 151.938 281.135 152.017C280.882 152.096 280.609 152.088 280.36 151.994Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M277.708 142.859L273.657 140.502C273.371 140.341 273.16 140.072 273.072 139.756C272.984 139.439 273.025 139.1 273.186 138.814C273.217 138.76 273.251 138.709 273.288 138.66L275.425 135.272C275.594 135.076 275.828 134.945 276.084 134.905C276.341 134.864 276.603 134.916 276.825 135.051L281.098 137.555C281.298 137.648 281.456 137.815 281.538 138.02C281.62 138.226 281.62 138.455 281.54 138.66L279.109 142.417C278.959 142.637 278.739 142.8 278.485 142.88C278.231 142.96 277.957 142.953 277.708 142.859Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M271.448 139.175L267.396 136.818C267.255 136.738 267.13 136.63 267.03 136.502C266.93 136.373 266.857 136.227 266.813 136.07C266.77 135.913 266.758 135.749 266.778 135.588C266.799 135.426 266.85 135.27 266.931 135.129C266.96 135.078 266.992 135.029 267.028 134.983L269.164 131.594C269.334 131.397 269.568 131.267 269.824 131.227C270.08 131.186 270.343 131.238 270.565 131.373L274.837 133.877C275.037 133.971 275.195 134.137 275.277 134.343C275.359 134.548 275.36 134.777 275.279 134.983L272.847 138.74C272.705 138.968 272.486 139.138 272.229 139.218C271.972 139.298 271.695 139.283 271.448 139.175Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M274.099 148.31L270.047 145.953C269.762 145.791 269.552 145.522 269.465 145.205C269.377 144.888 269.419 144.55 269.582 144.264C269.611 144.213 269.643 144.164 269.679 144.118L271.816 140.728C271.985 140.532 272.219 140.402 272.475 140.362C272.732 140.321 272.994 140.373 273.215 140.508L277.488 143.012C277.689 143.106 277.846 143.272 277.928 143.478C278.011 143.683 278.011 143.912 277.931 144.118L275.499 147.873C275.348 148.092 275.128 148.254 274.875 148.333C274.621 148.413 274.348 148.404 274.099 148.31Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M267.764 144.626L263.713 142.27C263.571 142.19 263.447 142.082 263.347 141.954C263.247 141.826 263.173 141.679 263.13 141.522C263.087 141.365 263.075 141.201 263.095 141.04C263.115 140.878 263.167 140.722 263.247 140.581C263.276 140.53 263.309 140.481 263.344 140.434L265.481 137.046C265.65 136.85 265.884 136.72 266.14 136.679C266.397 136.639 266.659 136.69 266.881 136.825L271.154 139.329C271.354 139.423 271.512 139.589 271.594 139.794C271.676 139.999 271.676 140.228 271.596 140.434L269.164 144.19C269.038 144.433 268.82 144.616 268.559 144.699C268.298 144.782 268.015 144.757 267.772 144.631L267.764 144.626Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M283.085 161.128L279.034 158.771C278.892 158.691 278.768 158.584 278.668 158.455C278.568 158.327 278.494 158.18 278.451 158.023C278.408 157.867 278.396 157.703 278.416 157.541C278.436 157.38 278.488 157.224 278.568 157.083C278.597 157.031 278.629 156.982 278.666 156.936L280.804 153.54C280.974 153.343 281.207 153.213 281.464 153.173C281.72 153.133 281.982 153.184 282.204 153.319L286.476 155.823C286.677 155.917 286.834 156.083 286.917 156.288C286.999 156.494 287 156.723 286.919 156.929L284.488 160.685C284.334 160.902 284.114 161.063 283.861 161.143C283.607 161.223 283.335 161.218 283.085 161.128Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M276.75 157.445L272.698 155.088C272.557 155.008 272.433 154.901 272.332 154.772C272.232 154.644 272.159 154.497 272.115 154.34C272.072 154.183 272.06 154.02 272.08 153.858C272.1 153.697 272.152 153.541 272.233 153.399C272.261 153.348 272.294 153.299 272.33 153.253L274.466 149.864C274.636 149.667 274.869 149.537 275.126 149.497C275.382 149.456 275.645 149.508 275.866 149.643L280.139 152.147C280.34 152.241 280.497 152.407 280.579 152.613C280.661 152.818 280.662 153.047 280.581 153.253L278.15 157.009C278.023 157.252 277.806 157.435 277.544 157.517C277.283 157.6 277 157.575 276.757 157.449L276.75 157.445Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M270.489 153.761L266.438 151.405C266.152 151.243 265.942 150.973 265.855 150.657C265.768 150.34 265.81 150.001 265.972 149.715C266.001 149.664 266.033 149.616 266.069 149.569L268.206 146.18C268.375 145.984 268.609 145.854 268.866 145.813C269.122 145.773 269.384 145.825 269.606 145.959L273.879 148.464C274.079 148.557 274.236 148.724 274.319 148.929C274.401 149.135 274.401 149.364 274.321 149.569L271.889 153.326C271.762 153.569 271.545 153.752 271.284 153.834C271.022 153.917 270.739 153.892 270.496 153.766L270.489 153.761Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M264.154 150.152L260.103 147.795C259.961 147.715 259.836 147.608 259.736 147.48C259.636 147.352 259.561 147.205 259.518 147.049C259.474 146.892 259.462 146.728 259.481 146.566C259.501 146.405 259.552 146.249 259.632 146.107C259.662 146.053 259.696 146.002 259.734 145.954L261.871 142.565C262.04 142.369 262.274 142.239 262.53 142.198C262.787 142.158 263.049 142.209 263.271 142.344L267.544 144.848C267.744 144.942 267.901 145.108 267.983 145.314C268.065 145.519 268.066 145.748 267.985 145.954L265.554 149.71C265.416 149.943 265.197 150.117 264.939 150.199C264.68 150.28 264.401 150.263 264.154 150.152Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M285.665 109.709L261.502 148.53L285.665 109.709Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M285.665 109.709L261.502 148.53L285.665 109.709Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M287.212 110.667L263.05 149.489L287.212 110.667Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M287.212 110.667L263.05 149.489L287.212 110.667Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M291.853 113.392L267.691 152.214L291.853 113.392Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M291.853 113.392L267.691 152.214L291.853 113.392Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M293.474 114.352L269.311 153.172L293.474 114.352Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M293.474 114.352L269.311 153.172L293.474 114.352Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M298.115 117.003L273.952 155.823L298.115 117.003Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M298.115 117.003L273.952 155.823L298.115 117.003Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M299.661 117.961L275.498 156.781L299.661 117.961Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M299.661 117.961L275.498 156.781L299.661 117.961Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M304.301 120.613L280.139 159.434L304.301 120.613Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M304.301 120.613L280.139 159.434L304.301 120.613Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M305.923 121.569L281.76 160.39L305.923 121.569Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M305.923 121.569L281.76 160.39L305.923 121.569Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M283.676 108.236L283.529 108.31L308.797 123.038L308.944 122.964L283.676 108.236Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M283.529 108.31V108.457L308.648 123.043V122.969L283.529 108.31Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M308.796 123.042L308.943 122.969L284.413 161.938L284.19 162.16L308.796 123.042Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M308.796 123.042L308.723 122.97L284.045 162.086L284.192 162.159L308.796 123.042Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M283.676 108.531L283.75 108.605L258.998 147.279L258.852 147.352L283.676 108.531Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M283.75 108.383L283.529 108.31L258.629 147.207L258.85 147.354L283.75 108.383Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M259.072 147.132L258.925 147.205L284.118 161.934V161.86L259.072 147.132Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M258.925 147.205L258.852 147.352L284.044 162.086L284.118 161.938L258.925 147.205Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M311.522 122.748L338.336 138.218L288.022 219.396L260.324 203.412L311.522 122.748Z",
    fill: "#D5C5E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M286.401 163.927L311.521 178.586L286.843 217.484L261.723 202.752L286.401 163.927Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M307.027 183.595L302.976 181.238C302.834 181.158 302.71 181.05 302.61 180.922C302.51 180.794 302.436 180.647 302.393 180.49C302.349 180.333 302.337 180.169 302.357 180.008C302.378 179.847 302.429 179.691 302.51 179.549C302.538 179.498 302.571 179.449 302.607 179.402L304.743 176.014C304.913 175.818 305.146 175.688 305.403 175.647C305.659 175.607 305.922 175.658 306.144 175.793L310.416 178.297C310.617 178.39 310.774 178.557 310.856 178.762C310.938 178.967 310.939 179.196 310.858 179.402L308.427 183.159C308.288 183.391 308.068 183.563 307.81 183.644C307.552 183.724 307.273 183.707 307.027 183.595Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M300.766 179.985L296.714 177.628C296.572 177.548 296.448 177.441 296.347 177.313C296.247 177.185 296.173 177.038 296.129 176.882C296.086 176.725 296.073 176.561 296.093 176.399C296.113 176.238 296.164 176.082 296.244 175.94C296.274 175.886 296.308 175.835 296.346 175.787L298.484 172.397C298.654 172.201 298.888 172.071 299.144 172.03C299.4 171.99 299.663 172.041 299.885 172.176L304.157 174.68C304.358 174.774 304.515 174.94 304.597 175.145C304.679 175.351 304.68 175.58 304.599 175.785L302.168 179.542C302.027 179.772 301.807 179.944 301.55 180.025C301.292 180.107 301.014 180.092 300.766 179.985Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M303.418 189.046L299.367 186.689C299.225 186.609 299.1 186.502 299 186.374C298.9 186.246 298.825 186.1 298.782 185.943C298.738 185.786 298.725 185.622 298.745 185.461C298.765 185.299 298.816 185.143 298.896 185.001C298.926 184.948 298.96 184.897 298.998 184.848L301.134 181.459C301.304 181.263 301.538 181.133 301.794 181.092C302.05 181.052 302.313 181.103 302.535 181.238L306.808 183.742C307.008 183.836 307.165 184.002 307.247 184.208C307.329 184.413 307.33 184.642 307.249 184.848L304.818 188.605C304.693 188.848 304.476 189.032 304.215 189.116C303.954 189.199 303.671 189.176 303.427 189.051L303.418 189.046Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M297.156 185.437L293.104 183.08C292.819 182.918 292.609 182.649 292.522 182.332C292.435 182.015 292.477 181.676 292.639 181.391C292.668 181.34 292.7 181.291 292.736 181.245L294.873 177.856C295.042 177.659 295.276 177.529 295.532 177.489C295.789 177.448 296.051 177.5 296.273 177.635L300.545 180.139C300.746 180.233 300.903 180.399 300.985 180.604C301.067 180.81 301.068 181.039 300.988 181.245L298.556 185.001C298.413 185.23 298.194 185.399 297.937 185.479C297.68 185.559 297.403 185.544 297.156 185.437Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M294.504 176.302L290.452 173.945C290.166 173.783 289.957 173.514 289.869 173.197C289.782 172.88 289.824 172.541 289.986 172.255C290.015 172.204 290.048 172.155 290.084 172.109L292.22 168.721C292.39 168.524 292.624 168.394 292.88 168.354C293.136 168.313 293.398 168.365 293.62 168.499L297.893 171.004C298.093 171.097 298.25 171.264 298.333 171.469C298.415 171.674 298.416 171.903 298.335 172.109L295.904 175.866C295.762 176.094 295.542 176.264 295.285 176.344C295.028 176.424 294.75 176.409 294.504 176.302Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M288.169 172.693L284.117 170.336C283.832 170.174 283.622 169.905 283.535 169.588C283.447 169.271 283.49 168.932 283.652 168.646C283.681 168.595 283.713 168.547 283.749 168.501L285.886 165.112C286.055 164.915 286.289 164.785 286.545 164.745C286.802 164.704 287.064 164.756 287.286 164.891L291.558 167.395C291.759 167.489 291.916 167.655 291.998 167.86C292.08 168.066 292.081 168.295 292 168.501L289.569 172.257C289.418 172.476 289.198 172.638 288.944 172.717C288.69 172.796 288.418 172.788 288.169 172.693Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M290.894 181.754L286.842 179.397C286.556 179.235 286.347 178.966 286.26 178.649C286.172 178.332 286.214 177.993 286.377 177.707C286.406 177.656 286.438 177.607 286.474 177.561L288.61 174.173C288.78 173.976 289.014 173.846 289.27 173.806C289.526 173.765 289.789 173.817 290.011 173.951L294.283 176.456C294.483 176.549 294.641 176.716 294.723 176.921C294.805 177.126 294.806 177.355 294.725 177.561L292.294 181.318C292.152 181.546 291.932 181.716 291.675 181.796C291.418 181.876 291.141 181.861 290.894 181.754Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M284.559 178.144L280.508 175.786C280.366 175.706 280.242 175.599 280.142 175.47C280.042 175.342 279.968 175.195 279.925 175.038C279.882 174.882 279.87 174.718 279.89 174.556C279.91 174.395 279.962 174.239 280.042 174.098C280.071 174.046 280.103 173.997 280.139 173.951L282.278 170.555C282.447 170.359 282.681 170.229 282.937 170.188C283.194 170.148 283.456 170.199 283.678 170.334L287.95 172.838C288.151 172.932 288.308 173.098 288.391 173.304C288.473 173.509 288.473 173.738 288.393 173.945L285.961 177.7C285.82 177.93 285.601 178.102 285.343 178.183C285.085 178.265 284.807 178.251 284.559 178.144Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M299.955 194.572L295.904 192.215C295.762 192.135 295.637 192.028 295.537 191.9C295.437 191.772 295.362 191.625 295.319 191.468C295.275 191.312 295.263 191.148 295.282 190.986C295.302 190.825 295.353 190.669 295.433 190.527C295.463 190.473 295.497 190.422 295.535 190.374L297.672 186.985C297.841 186.788 298.075 186.658 298.331 186.618C298.587 186.577 298.85 186.629 299.072 186.763L303.345 189.268C303.545 189.362 303.702 189.528 303.784 189.733C303.866 189.939 303.867 190.168 303.786 190.374L301.355 194.13C301.226 194.372 301.007 194.554 300.745 194.637C300.484 194.719 300.2 194.696 299.955 194.572Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M293.62 190.962L289.568 188.605C289.282 188.444 289.072 188.175 288.983 187.858C288.895 187.542 288.936 187.203 289.098 186.917C289.128 186.863 289.162 186.812 289.2 186.763L291.337 183.375C291.506 183.178 291.74 183.048 291.996 183.008C292.253 182.967 292.515 183.019 292.737 183.154L297.009 185.658C297.21 185.751 297.367 185.918 297.449 186.123C297.531 186.328 297.532 186.557 297.451 186.763L295.02 190.52C294.882 190.753 294.663 190.927 294.405 191.008C294.146 191.09 293.867 191.073 293.62 190.962Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M296.419 200.17L292.367 197.813C292.081 197.651 291.872 197.382 291.785 197.065C291.697 196.748 291.74 196.409 291.902 196.124C291.931 196.073 291.963 196.024 291.999 195.978L294.136 192.589C294.305 192.392 294.539 192.262 294.795 192.222C295.052 192.181 295.314 192.233 295.536 192.368L299.808 194.872C300.009 194.966 300.166 195.132 300.248 195.337C300.33 195.543 300.331 195.772 300.25 195.978L297.819 199.734C297.68 199.966 297.46 200.138 297.202 200.219C296.944 200.299 296.665 200.282 296.419 200.17Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M290.084 196.56L286.032 194.203C285.891 194.123 285.766 194.016 285.666 193.887C285.566 193.759 285.492 193.612 285.449 193.455C285.406 193.298 285.394 193.134 285.414 192.973C285.434 192.811 285.486 192.655 285.566 192.514C285.595 192.463 285.628 192.414 285.664 192.368L287.8 188.979C287.969 188.782 288.203 188.652 288.46 188.612C288.716 188.571 288.978 188.623 289.2 188.758L293.473 191.262C293.674 191.356 293.831 191.522 293.913 191.727C293.995 191.933 293.996 192.162 293.915 192.368L291.484 196.124C291.354 196.365 291.134 196.546 290.873 196.628C290.611 196.709 290.328 196.685 290.084 196.56Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M287.359 187.278L283.308 184.921C283.166 184.841 283.042 184.734 282.942 184.605C282.841 184.477 282.768 184.33 282.724 184.173C282.681 184.016 282.669 183.852 282.689 183.691C282.709 183.529 282.761 183.373 282.842 183.232C282.871 183.181 282.903 183.132 282.939 183.086L285.075 179.697C285.245 179.501 285.478 179.371 285.735 179.33C285.991 179.29 286.254 179.341 286.475 179.476L290.748 181.981C290.949 182.074 291.106 182.24 291.188 182.446C291.27 182.651 291.271 182.88 291.19 183.086L288.759 186.842C288.629 187.083 288.41 187.264 288.148 187.346C287.886 187.427 287.603 187.403 287.359 187.278Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M281.024 183.669L276.972 181.311C276.831 181.231 276.706 181.124 276.606 180.995C276.506 180.867 276.433 180.72 276.39 180.563C276.346 180.406 276.334 180.243 276.355 180.081C276.375 179.92 276.426 179.764 276.507 179.622C276.536 179.571 276.568 179.523 276.604 179.476L278.74 176.087C278.91 175.891 279.144 175.761 279.4 175.721C279.656 175.68 279.919 175.732 280.141 175.866L284.413 178.371C284.613 178.464 284.771 178.631 284.853 178.836C284.935 179.041 284.936 179.27 284.855 179.476L282.424 183.233C282.285 183.465 282.065 183.637 281.807 183.718C281.549 183.798 281.27 183.781 281.024 183.669Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M283.749 192.877L279.698 190.519C279.556 190.439 279.432 190.332 279.332 190.204C279.232 190.075 279.158 189.929 279.115 189.772C279.071 189.615 279.06 189.451 279.08 189.29C279.1 189.128 279.151 188.972 279.232 188.831C279.261 188.78 279.293 188.73 279.329 188.684L281.465 185.295C281.635 185.099 281.869 184.969 282.125 184.928C282.381 184.888 282.644 184.94 282.866 185.074L287.139 187.579C287.339 187.672 287.496 187.839 287.578 188.044C287.66 188.249 287.661 188.478 287.58 188.684L285.149 192.44C285.007 192.669 284.787 192.839 284.53 192.919C284.273 192.999 283.996 192.984 283.749 192.877Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M277.414 189.268L273.362 186.911C273.221 186.831 273.096 186.724 272.996 186.595C272.896 186.467 272.823 186.32 272.779 186.163C272.736 186.006 272.724 185.842 272.744 185.681C272.765 185.519 272.816 185.364 272.897 185.222C272.925 185.171 272.958 185.122 272.994 185.076L275.13 181.687C275.3 181.491 275.534 181.361 275.79 181.32C276.046 181.28 276.309 181.331 276.531 181.466L280.803 183.971C281.003 184.064 281.161 184.23 281.243 184.436C281.325 184.641 281.326 184.87 281.245 185.076L278.814 188.832C278.66 189.047 278.44 189.206 278.187 189.285C277.934 189.364 277.663 189.358 277.414 189.268Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M292.957 205.695L288.906 203.338C288.765 203.258 288.64 203.15 288.54 203.022C288.44 202.893 288.366 202.747 288.323 202.59C288.28 202.433 288.268 202.269 288.288 202.107C288.308 201.946 288.36 201.79 288.44 201.649C288.469 201.598 288.502 201.549 288.537 201.502L290.674 198.114C290.843 197.917 291.077 197.787 291.334 197.747C291.59 197.706 291.852 197.758 292.074 197.893L296.347 200.397C296.548 200.491 296.705 200.657 296.787 200.862C296.869 201.067 296.87 201.296 296.789 201.502L294.358 205.259C294.238 205.5 294.028 205.683 293.774 205.769C293.519 205.855 293.241 205.836 293 205.717C292.985 205.71 292.971 205.703 292.957 205.695Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M286.695 202.085L282.644 199.728C282.502 199.648 282.378 199.54 282.278 199.412C282.178 199.283 282.104 199.137 282.061 198.98C282.018 198.823 282.006 198.659 282.026 198.498C282.046 198.336 282.098 198.18 282.178 198.039C282.207 197.988 282.239 197.939 282.276 197.892L284.412 194.503C284.581 194.307 284.815 194.177 285.071 194.136C285.328 194.096 285.59 194.148 285.812 194.282L290.085 196.787C290.285 196.88 290.442 197.047 290.524 197.252C290.607 197.457 290.607 197.686 290.527 197.892L288.095 201.649C287.956 201.881 287.736 202.053 287.478 202.134C287.22 202.214 286.942 202.197 286.695 202.085Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M289.347 211.146L285.296 208.79C285.155 208.709 285.03 208.602 284.93 208.474C284.83 208.345 284.756 208.198 284.713 208.041C284.67 207.884 284.658 207.721 284.678 207.559C284.698 207.397 284.75 207.241 284.83 207.1C284.859 207.049 284.892 207 284.927 206.954L287.064 203.565C287.233 203.369 287.467 203.238 287.723 203.198C287.98 203.158 288.242 203.209 288.464 203.344L292.737 205.849C292.937 205.942 293.095 206.108 293.177 206.314C293.259 206.519 293.26 206.748 293.179 206.954L290.748 210.71C290.628 210.951 290.418 211.135 290.164 211.22C289.909 211.306 289.631 211.288 289.39 211.169C289.375 211.161 289.361 211.154 289.347 211.146Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M283.086 207.536L279.034 205.179C278.893 205.099 278.768 204.992 278.668 204.864C278.567 204.736 278.493 204.59 278.45 204.433C278.406 204.276 278.394 204.112 278.413 203.951C278.433 203.789 278.484 203.633 278.564 203.491C278.594 203.438 278.628 203.386 278.666 203.338L280.805 199.949C280.974 199.753 281.208 199.623 281.464 199.582C281.721 199.542 281.983 199.593 282.205 199.728L286.478 202.233C286.678 202.326 286.836 202.492 286.918 202.698C287 202.903 287 203.132 286.919 203.338L284.488 207.094C284.347 207.324 284.127 207.496 283.87 207.577C283.612 207.658 283.334 207.644 283.086 207.536Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M280.434 198.401L276.382 196.045C276.24 195.965 276.116 195.858 276.015 195.73C275.915 195.602 275.841 195.455 275.797 195.298C275.754 195.142 275.741 194.978 275.761 194.816C275.781 194.655 275.832 194.499 275.912 194.357C275.942 194.303 275.976 194.252 276.014 194.203L278.151 190.815C278.32 190.618 278.554 190.489 278.81 190.448C279.066 190.408 279.329 190.459 279.551 190.594L283.823 193.098C284.024 193.191 284.181 193.358 284.263 193.563C284.345 193.768 284.346 193.997 284.265 194.203L281.834 197.96C281.693 198.189 281.473 198.36 281.216 198.441C280.959 198.522 280.682 198.508 280.434 198.401Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M274.099 194.793L270.048 192.436C269.906 192.356 269.782 192.248 269.682 192.12C269.582 191.991 269.508 191.845 269.465 191.688C269.422 191.531 269.41 191.367 269.43 191.206C269.45 191.044 269.502 190.888 269.582 190.747C269.611 190.695 269.643 190.647 269.679 190.6L271.816 187.212C271.985 187.015 272.219 186.885 272.476 186.845C272.732 186.804 272.994 186.856 273.216 186.991L277.488 189.495C277.689 189.589 277.846 189.755 277.928 189.96C278.011 190.166 278.011 190.394 277.931 190.6L275.499 194.357C275.36 194.589 275.141 194.761 274.882 194.842C274.624 194.922 274.346 194.905 274.099 194.793Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M276.825 203.853L272.773 201.496C272.487 201.334 272.278 201.065 272.19 200.748C272.103 200.431 272.145 200.092 272.308 199.807C272.336 199.756 272.369 199.707 272.405 199.661L274.541 196.272C274.711 196.075 274.945 195.945 275.201 195.905C275.457 195.864 275.72 195.916 275.942 196.051L280.214 198.555C280.414 198.649 280.572 198.815 280.654 199.02C280.736 199.226 280.737 199.455 280.656 199.661L278.225 203.417C278.083 203.646 277.863 203.815 277.606 203.895C277.349 203.975 277.072 203.961 276.825 203.853Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M270.489 200.243L266.438 197.886C266.296 197.805 266.172 197.698 266.072 197.57C265.972 197.441 265.898 197.294 265.855 197.138C265.812 196.981 265.8 196.817 265.82 196.655C265.84 196.494 265.892 196.338 265.972 196.197C266.001 196.146 266.034 196.097 266.069 196.051L268.206 192.662C268.375 192.465 268.609 192.335 268.866 192.295C269.122 192.254 269.384 192.306 269.606 192.441L273.878 194.945C274.079 195.039 274.236 195.205 274.319 195.41C274.401 195.616 274.401 195.845 274.321 196.051L271.889 199.807C271.747 200.036 271.527 200.206 271.27 200.286C271.013 200.365 270.736 200.35 270.489 200.243Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M285.737 216.671L281.686 214.314C281.545 214.233 281.42 214.126 281.32 213.998C281.22 213.869 281.146 213.723 281.103 213.566C281.06 213.409 281.048 213.245 281.068 213.084C281.088 212.922 281.14 212.766 281.22 212.625C281.249 212.574 281.282 212.525 281.317 212.479L283.454 209.09C283.623 208.894 283.857 208.764 284.113 208.723C284.37 208.683 284.632 208.734 284.854 208.869L289.127 211.374C289.327 211.467 289.485 211.633 289.567 211.839C289.649 212.044 289.649 212.273 289.569 212.479L287.138 216.235C286.998 216.467 286.779 216.64 286.521 216.72C286.262 216.8 285.984 216.783 285.737 216.671Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M279.402 213.061L275.352 210.704C275.21 210.624 275.086 210.517 274.986 210.388C274.886 210.26 274.812 210.113 274.769 209.956C274.725 209.799 274.713 209.635 274.733 209.474C274.754 209.312 274.805 209.156 274.886 209.015C274.915 208.964 274.947 208.915 274.983 208.869L277.121 205.473C277.291 205.276 277.525 205.147 277.781 205.106C278.037 205.066 278.3 205.117 278.521 205.252L282.794 207.756C282.994 207.85 283.152 208.016 283.234 208.221C283.316 208.426 283.317 208.655 283.237 208.861L280.805 212.618C280.667 212.852 280.447 213.026 280.188 213.108C279.93 213.19 279.65 213.173 279.402 213.061Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M273.141 209.378L269.09 207.021C268.948 206.941 268.824 206.834 268.724 206.705C268.624 206.577 268.55 206.43 268.507 206.273C268.463 206.116 268.451 205.952 268.472 205.791C268.492 205.629 268.543 205.473 268.624 205.331C268.653 205.281 268.685 205.232 268.721 205.186L270.857 201.797C271.027 201.6 271.261 201.47 271.517 201.43C271.773 201.389 272.036 201.441 272.258 201.576L276.531 204.08C276.731 204.174 276.888 204.34 276.97 204.545C277.052 204.751 277.053 204.98 276.972 205.186L274.541 208.942C274.402 209.174 274.182 209.346 273.924 209.427C273.666 209.507 273.387 209.49 273.141 209.378Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M266.879 205.769L262.828 203.411C262.686 203.331 262.562 203.223 262.462 203.095C262.362 202.967 262.288 202.82 262.245 202.663C262.202 202.506 262.19 202.343 262.21 202.181C262.23 202.02 262.282 201.864 262.362 201.722C262.391 201.671 262.423 201.622 262.459 201.576L264.598 198.18C264.768 197.984 265.001 197.854 265.257 197.814C265.514 197.773 265.776 197.825 265.998 197.959L270.27 200.464C270.471 200.557 270.628 200.723 270.711 200.929C270.793 201.134 270.793 201.363 270.713 201.569L268.281 205.325C268.14 205.555 267.92 205.727 267.663 205.809C267.405 205.89 267.127 205.876 266.879 205.769Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M288.317 165.252L264.154 204.073L288.317 165.252Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M288.317 165.252L264.154 204.073L288.317 165.252Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M289.937 166.211L265.774 205.031L289.937 166.211Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M289.937 166.211L265.774 205.031L289.937 166.211Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M294.578 168.936L270.416 207.756L294.578 168.936Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M294.578 168.936L270.416 207.756L294.578 168.936Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M296.125 169.967L271.962 208.788L296.125 169.967Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M296.125 169.967L271.962 208.788L296.125 169.967Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M300.766 172.546L276.604 211.366L300.766 172.546Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M300.766 172.546L276.604 211.366L300.766 172.546Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M302.386 173.577L278.224 212.398L302.386 173.577Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M302.386 173.577L278.224 212.398L302.386 173.577Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M307.028 176.228L282.866 215.05L307.028 176.228Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M307.028 176.228L282.866 215.05L307.028 176.228Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M308.575 177.187L284.412 216.008L308.575 177.187Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M308.575 177.187L284.412 216.008L308.575 177.187Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M286.326 163.854L286.253 163.928L311.52 178.586L311.594 178.513L286.326 163.854Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M286.254 163.927L286.18 164L311.3 178.659L311.373 178.513L286.254 163.927Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M311.521 178.585L311.595 178.512L287.064 217.554L286.842 217.701L311.521 178.585Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M311.521 178.585L311.374 178.512L286.697 217.628L286.844 217.701L311.521 178.585Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M286.328 164.147L286.475 164.221L261.651 202.889L261.504 202.963L286.328 164.147Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M286.402 164L286.255 163.927L261.356 202.824L261.503 202.971L286.402 164Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M261.724 202.748H261.577L286.77 217.55V217.402L261.724 202.748Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M261.577 202.748L261.504 202.969L286.697 217.629L286.77 217.555L261.577 202.748Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M338.336 138.218L339.219 139.47L288.905 220.648L288.022 219.396L338.336 138.218Z",
    fill: "#3D3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M288.022 219.396L288.905 220.648L261.576 204.736L260.324 203.409L288.022 219.396Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M311.374 124.442L336.494 139.102L311.816 177.924L286.77 163.19L311.374 124.442Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M332.073 144.111L328.021 141.754C327.88 141.674 327.755 141.567 327.655 141.439C327.554 141.311 327.48 141.164 327.436 141.007C327.393 140.851 327.38 140.687 327.4 140.525C327.419 140.364 327.471 140.207 327.551 140.066C327.581 140.012 327.615 139.961 327.653 139.912L329.789 136.524C329.959 136.328 330.192 136.197 330.449 136.157C330.705 136.117 330.968 136.168 331.189 136.303L335.462 138.808C335.663 138.901 335.82 139.067 335.902 139.273C335.984 139.478 335.985 139.707 335.904 139.912L333.473 143.669C333.32 143.885 333.1 144.045 332.847 144.125C332.594 144.205 332.322 144.2 332.073 144.111Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M325.738 140.427L321.687 138.07C321.545 137.99 321.421 137.882 321.321 137.754C321.221 137.626 321.147 137.479 321.104 137.322C321.06 137.165 321.048 137.002 321.069 136.84C321.089 136.679 321.14 136.523 321.221 136.381C321.25 136.33 321.282 136.281 321.318 136.234L323.454 132.846C323.624 132.65 323.858 132.52 324.114 132.479C324.37 132.439 324.633 132.491 324.855 132.625L329.128 135.13C329.328 135.223 329.485 135.389 329.567 135.595C329.649 135.8 329.65 136.029 329.569 136.234L327.138 139.991C326.999 140.223 326.779 140.395 326.521 140.476C326.263 140.556 325.984 140.539 325.738 140.427Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M328.463 149.562L324.412 147.206C324.257 147.118 324.122 146.998 324.017 146.854C323.912 146.71 323.84 146.544 323.805 146.37C323.77 146.195 323.773 146.014 323.814 145.841C323.855 145.667 323.934 145.504 324.044 145.364L326.18 141.975C326.35 141.779 326.583 141.649 326.84 141.608C327.096 141.568 327.358 141.62 327.58 141.754L331.853 144.258C332.054 144.351 332.211 144.518 332.293 144.723C332.375 144.929 332.376 145.158 332.295 145.364L329.864 149.12C329.71 149.337 329.491 149.497 329.238 149.576C328.985 149.656 328.713 149.651 328.463 149.562Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M322.128 145.879L318.077 143.521C317.936 143.441 317.811 143.334 317.711 143.206C317.611 143.077 317.538 142.931 317.494 142.774C317.451 142.617 317.439 142.453 317.459 142.292C317.479 142.13 317.531 141.974 317.611 141.833C317.64 141.782 317.673 141.733 317.709 141.686L319.847 138.291C320.016 138.095 320.25 137.965 320.507 137.924C320.763 137.884 321.025 137.935 321.247 138.07L325.519 140.573C325.72 140.667 325.877 140.833 325.96 141.039C326.042 141.244 326.043 141.473 325.962 141.68L323.531 145.436C323.406 145.679 323.19 145.864 322.929 145.948C322.669 146.033 322.386 146.01 322.142 145.886L322.128 145.879Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M319.476 136.745L315.425 134.388C315.283 134.308 315.159 134.201 315.058 134.073C314.958 133.944 314.884 133.798 314.84 133.641C314.796 133.484 314.784 133.321 314.803 133.159C314.823 132.997 314.874 132.841 314.954 132.7C314.984 132.646 315.018 132.595 315.056 132.546L317.193 129.157C317.362 128.961 317.596 128.831 317.852 128.79C318.109 128.75 318.371 128.802 318.593 128.936L322.866 131.441C323.066 131.534 323.224 131.701 323.306 131.906C323.388 132.111 323.388 132.34 323.308 132.546L320.876 136.303C320.751 136.546 320.534 136.73 320.273 136.814C320.013 136.898 319.729 136.875 319.486 136.75L319.476 136.745Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M313.215 133.134L309.163 130.778C308.877 130.615 308.668 130.346 308.58 130.029C308.493 129.712 308.535 129.373 308.698 129.087C308.726 129.036 308.759 128.988 308.795 128.942L310.931 125.553C311.101 125.357 311.335 125.227 311.591 125.186C311.847 125.146 312.11 125.197 312.332 125.332L316.604 127.837C316.804 127.93 316.962 128.096 317.044 128.302C317.126 128.507 317.127 128.736 317.046 128.942L314.614 132.698C314.472 132.927 314.253 133.096 313.996 133.176C313.739 133.256 313.462 133.241 313.215 133.134Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M315.866 142.196L311.815 139.839C311.673 139.759 311.549 139.651 311.449 139.523C311.349 139.395 311.275 139.248 311.232 139.091C311.189 138.934 311.177 138.77 311.197 138.609C311.217 138.447 311.269 138.291 311.349 138.15C311.378 138.099 311.41 138.05 311.446 138.003L313.583 134.615C313.752 134.418 313.986 134.288 314.242 134.248C314.499 134.207 314.761 134.259 314.983 134.394L319.256 136.898C319.456 136.992 319.613 137.158 319.695 137.363C319.778 137.569 319.778 137.798 319.697 138.003L317.266 141.76C317.136 142.001 316.917 142.182 316.655 142.263C316.393 142.345 316.11 142.321 315.866 142.196Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M309.531 138.586L305.48 136.229C305.338 136.15 305.214 136.042 305.113 135.914C305.013 135.786 304.939 135.64 304.895 135.483C304.851 135.326 304.839 135.162 304.859 135.001C304.878 134.839 304.929 134.683 305.009 134.541C305.039 134.488 305.074 134.436 305.111 134.388L307.248 130.999C307.417 130.803 307.651 130.673 307.908 130.632C308.164 130.592 308.426 130.643 308.648 130.778L312.921 133.283C313.121 133.376 313.279 133.542 313.361 133.748C313.443 133.953 313.443 134.182 313.363 134.388L310.932 138.144C310.793 138.377 310.574 138.551 310.316 138.632C310.058 138.714 309.778 138.697 309.531 138.586Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M324.928 155.087L320.876 152.73C320.735 152.65 320.61 152.542 320.51 152.414C320.41 152.286 320.337 152.139 320.294 151.982C320.25 151.825 320.238 151.661 320.259 151.5C320.279 151.338 320.33 151.182 320.411 151.041C320.44 150.99 320.472 150.941 320.508 150.895L322.644 147.506C322.814 147.31 323.048 147.18 323.304 147.14C323.56 147.099 323.822 147.151 324.044 147.285L328.317 149.79C328.517 149.883 328.675 150.049 328.757 150.254C328.839 150.46 328.84 150.689 328.759 150.895L326.328 154.651C326.189 154.883 325.969 155.056 325.711 155.136C325.453 155.217 325.174 155.199 324.928 155.087Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M318.666 151.404L314.615 149.047C314.473 148.967 314.349 148.859 314.249 148.731C314.149 148.603 314.075 148.456 314.032 148.299C313.989 148.142 313.977 147.978 313.997 147.817C314.017 147.655 314.069 147.499 314.149 147.358C314.178 147.307 314.21 147.258 314.246 147.212L316.383 143.823C316.552 143.627 316.786 143.497 317.043 143.456C317.299 143.416 317.561 143.467 317.783 143.602L322.055 146.107C322.256 146.2 322.413 146.366 322.495 146.571C322.578 146.777 322.578 147.006 322.498 147.212L320.067 150.968C319.937 151.209 319.717 151.39 319.455 151.472C319.194 151.553 318.91 151.529 318.666 151.404Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M321.392 160.612L317.341 158.255C317.199 158.175 317.074 158.068 316.974 157.94C316.873 157.812 316.799 157.665 316.755 157.509C316.712 157.352 316.699 157.188 316.719 157.027C316.738 156.865 316.79 156.709 316.87 156.567C316.9 156.514 316.934 156.462 316.972 156.414L319.111 153.024C319.28 152.827 319.514 152.697 319.77 152.657C320.026 152.616 320.289 152.668 320.51 152.802L324.783 155.307C324.984 155.401 325.141 155.567 325.223 155.772C325.305 155.978 325.306 156.207 325.225 156.413L322.794 160.169C322.669 160.413 322.453 160.597 322.192 160.682C321.932 160.766 321.649 160.743 321.405 160.619L321.392 160.612Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M315.057 157.075L311.005 154.719C310.72 154.557 310.51 154.287 310.423 153.97C310.336 153.654 310.378 153.315 310.54 153.029C310.569 152.978 310.601 152.929 310.637 152.883L312.774 149.494C312.944 149.298 313.177 149.168 313.433 149.128C313.69 149.087 313.952 149.139 314.174 149.273L318.446 151.778C318.647 151.871 318.804 152.037 318.886 152.243C318.968 152.448 318.969 152.677 318.889 152.883L316.458 156.639C316.307 156.858 316.087 157.02 315.833 157.099C315.579 157.178 315.306 157.17 315.057 157.075Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M312.332 147.794L308.28 145.437C308.138 145.356 308.014 145.249 307.914 145.121C307.814 144.992 307.741 144.845 307.697 144.689C307.654 144.532 307.642 144.368 307.662 144.206C307.683 144.045 307.734 143.889 307.815 143.748C307.843 143.697 307.876 143.648 307.912 143.602L310.048 140.212C310.218 140.016 310.452 139.886 310.708 139.845C310.964 139.805 311.227 139.857 311.449 139.992L315.721 142.496C315.921 142.59 316.079 142.756 316.161 142.961C316.243 143.167 316.244 143.396 316.163 143.602L313.731 147.358C313.58 147.577 313.361 147.739 313.107 147.818C312.853 147.897 312.58 147.888 312.332 147.794Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M306.07 144.111L302.018 141.754C301.732 141.593 301.522 141.324 301.433 141.007C301.345 140.691 301.386 140.352 301.548 140.066C301.578 140.012 301.612 139.961 301.65 139.912L303.786 136.524C303.956 136.328 304.19 136.197 304.446 136.157C304.702 136.117 304.965 136.168 305.187 136.303L309.459 138.808C309.659 138.901 309.817 139.067 309.899 139.272C309.981 139.478 309.982 139.707 309.901 139.912L307.47 143.669C307.329 143.899 307.109 144.069 306.852 144.15C306.595 144.232 306.318 144.217 306.07 144.111Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M308.722 153.318L304.67 150.961C304.384 150.798 304.175 150.529 304.087 150.212C304 149.895 304.042 149.557 304.205 149.271C304.233 149.22 304.266 149.171 304.302 149.125L306.438 145.736C306.608 145.539 306.842 145.409 307.098 145.369C307.354 145.328 307.617 145.38 307.839 145.515L312.111 148.019C312.311 148.113 312.469 148.279 312.551 148.485C312.633 148.69 312.634 148.919 312.553 149.125L310.121 152.882C309.982 153.114 309.763 153.286 309.505 153.367C309.247 153.447 308.968 153.43 308.722 153.318Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M302.386 149.71L298.335 147.352C298.193 147.271 298.069 147.164 297.969 147.035C297.869 146.907 297.795 146.76 297.752 146.603C297.708 146.446 297.696 146.282 297.717 146.121C297.737 145.959 297.788 145.803 297.869 145.662C297.898 145.611 297.93 145.562 297.966 145.515L300.102 142.127C300.272 141.931 300.506 141.801 300.762 141.76C301.018 141.72 301.281 141.771 301.503 141.906L305.776 144.41C305.976 144.504 306.133 144.67 306.215 144.875C306.297 145.081 306.298 145.31 306.217 145.515L303.786 149.272C303.647 149.504 303.428 149.677 303.17 149.758C302.911 149.839 302.632 149.821 302.386 149.71Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M318.003 166.211L313.952 163.853C313.81 163.774 313.685 163.667 313.585 163.539C313.485 163.411 313.41 163.264 313.367 163.107C313.323 162.951 313.311 162.787 313.33 162.625C313.35 162.464 313.401 162.308 313.481 162.166C313.511 162.112 313.545 162.061 313.583 162.012L315.719 158.624C315.889 158.427 316.123 158.297 316.379 158.257C316.635 158.216 316.898 158.268 317.12 158.403L321.393 160.907C321.593 161.001 321.75 161.167 321.832 161.372C321.914 161.578 321.915 161.806 321.834 162.012L319.403 165.769C319.25 165.985 319.03 166.145 318.777 166.225C318.525 166.305 318.253 166.3 318.003 166.211Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M311.668 162.527L307.616 160.17C307.33 160.007 307.121 159.738 307.034 159.421C306.946 159.104 306.989 158.765 307.151 158.479C307.179 158.428 307.212 158.379 307.248 158.333L309.385 154.945C309.554 154.748 309.788 154.618 310.044 154.578C310.3 154.537 310.563 154.589 310.785 154.723L315.058 157.228C315.258 157.321 315.415 157.488 315.497 157.693C315.579 157.899 315.58 158.128 315.499 158.333L313.068 162.09C312.933 162.326 312.713 162.502 312.454 162.583C312.194 162.664 311.913 162.644 311.668 162.527Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M314.392 171.662L310.341 169.305C310.2 169.225 310.075 169.118 309.975 168.989C309.875 168.861 309.801 168.714 309.758 168.557C309.715 168.4 309.703 168.236 309.723 168.075C309.743 167.913 309.795 167.757 309.875 167.616C309.904 167.565 309.937 167.516 309.973 167.47L312.109 164.081C312.279 163.884 312.512 163.754 312.769 163.714C313.025 163.673 313.287 163.725 313.509 163.86L317.782 166.364C317.983 166.458 318.14 166.624 318.222 166.83C318.304 167.035 318.305 167.264 318.224 167.47L315.793 171.226C315.638 171.441 315.418 171.6 315.166 171.679C314.913 171.758 314.642 171.752 314.392 171.662Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M308.058 168.052L304.006 165.695C303.72 165.534 303.51 165.265 303.422 164.948C303.333 164.632 303.375 164.293 303.536 164.007C303.566 163.953 303.6 163.902 303.638 163.854L305.775 160.465C305.944 160.269 306.178 160.139 306.434 160.098C306.691 160.058 306.953 160.109 307.175 160.244L311.448 162.748C311.648 162.841 311.806 163.008 311.888 163.213C311.97 163.419 311.97 163.648 311.89 163.854L309.459 167.61C309.308 167.83 309.089 167.993 308.835 168.073C308.581 168.153 308.307 168.146 308.058 168.052Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M305.407 158.844L301.356 156.487C301.069 156.326 300.859 156.057 300.771 155.741C300.682 155.424 300.723 155.085 300.885 154.799C300.915 154.745 300.949 154.694 300.987 154.645L303.123 151.257C303.293 151.06 303.526 150.93 303.783 150.89C304.039 150.849 304.302 150.901 304.524 151.035L308.797 153.54C308.997 153.633 309.154 153.8 309.236 154.005C309.318 154.211 309.319 154.44 309.238 154.645L306.807 158.402C306.682 158.646 306.465 158.83 306.204 158.913C305.943 158.997 305.66 158.974 305.416 158.849L305.407 158.844Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M299.145 155.235L295.094 152.878C294.952 152.797 294.828 152.69 294.728 152.562C294.628 152.433 294.554 152.286 294.511 152.13C294.468 151.973 294.456 151.809 294.476 151.647C294.496 151.486 294.548 151.33 294.628 151.188C294.657 151.137 294.689 151.088 294.725 151.041L296.862 147.653C297.031 147.456 297.265 147.326 297.521 147.286C297.778 147.245 298.04 147.297 298.262 147.432L302.535 149.936C302.735 150.03 302.892 150.196 302.974 150.401C303.056 150.607 303.057 150.836 302.976 151.041L300.545 154.798C300.403 155.026 300.183 155.196 299.926 155.276C299.669 155.356 299.392 155.342 299.145 155.235Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M301.797 164.369L297.746 162.012C297.604 161.932 297.48 161.824 297.38 161.696C297.28 161.568 297.206 161.421 297.163 161.264C297.119 161.107 297.107 160.943 297.128 160.782C297.148 160.62 297.199 160.464 297.28 160.323C297.309 160.272 297.341 160.223 297.377 160.177L299.513 156.787C299.683 156.591 299.917 156.461 300.173 156.421C300.43 156.38 300.692 156.432 300.914 156.567L305.187 159.072C305.387 159.165 305.544 159.331 305.626 159.536C305.708 159.742 305.709 159.971 305.628 160.176L303.197 163.933C303.046 164.152 302.826 164.314 302.572 164.393C302.319 164.472 302.045 164.464 301.797 164.369Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M295.462 160.686L291.41 158.329C291.269 158.249 291.144 158.142 291.044 158.014C290.943 157.885 290.869 157.739 290.825 157.582C290.782 157.425 290.769 157.262 290.789 157.1C290.808 156.938 290.86 156.782 290.94 156.641C290.97 156.587 291.004 156.536 291.042 156.487L293.178 153.098C293.348 152.902 293.581 152.772 293.838 152.731C294.094 152.691 294.357 152.743 294.578 152.877L298.851 155.382C299.052 155.475 299.209 155.642 299.291 155.847C299.373 156.052 299.374 156.281 299.293 156.487L296.862 160.243C296.737 160.487 296.52 160.671 296.259 160.755C295.998 160.839 295.715 160.815 295.471 160.691L295.462 160.686Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M310.784 177.113L306.733 174.756C306.591 174.676 306.467 174.569 306.367 174.44C306.267 174.312 306.193 174.165 306.15 174.008C306.106 173.852 306.095 173.688 306.115 173.526C306.135 173.365 306.186 173.209 306.267 173.067C306.296 173.016 306.328 172.967 306.364 172.921L308.501 169.532C308.67 169.336 308.904 169.206 309.16 169.165C309.416 169.125 309.679 169.176 309.901 169.311L314.174 171.815C314.374 171.909 314.531 172.075 314.613 172.281C314.695 172.486 314.696 172.715 314.615 172.921L312.184 176.677C312.054 176.919 311.835 177.099 311.573 177.181C311.311 177.262 311.028 177.238 310.784 177.113Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M304.449 173.504L300.397 171.147C300.111 170.986 299.901 170.717 299.812 170.4C299.724 170.084 299.765 169.745 299.927 169.459C299.957 169.405 299.991 169.354 300.029 169.305L302.168 165.916C302.337 165.719 302.571 165.589 302.827 165.549C303.083 165.508 303.346 165.56 303.567 165.695L307.84 168.199C308.041 168.293 308.198 168.459 308.28 168.664C308.362 168.869 308.363 169.098 308.282 169.304L305.851 173.06C305.71 173.29 305.49 173.462 305.233 173.544C304.975 173.625 304.697 173.611 304.449 173.504Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M298.187 169.82L294.136 167.463C293.994 167.383 293.87 167.276 293.769 167.148C293.669 167.02 293.595 166.873 293.551 166.717C293.507 166.56 293.495 166.396 293.514 166.235C293.534 166.073 293.585 165.917 293.665 165.775C293.695 165.722 293.729 165.67 293.767 165.622L295.904 162.233C296.073 162.036 296.307 161.906 296.563 161.866C296.82 161.826 297.082 161.877 297.304 162.012L301.577 164.516C301.777 164.61 301.934 164.776 302.017 164.982C302.099 165.187 302.099 165.416 302.018 165.622L299.587 169.378C299.446 169.608 299.227 169.779 298.969 169.86C298.712 169.941 298.435 169.927 298.187 169.82Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M291.853 166.21L287.801 163.853C287.66 163.773 287.535 163.666 287.435 163.538C287.334 163.41 287.26 163.264 287.216 163.107C287.173 162.95 287.16 162.786 287.18 162.625C287.199 162.463 287.251 162.307 287.33 162.165C287.361 162.112 287.395 162.06 287.433 162.011L289.569 158.623C289.739 158.427 289.972 158.297 290.229 158.256C290.485 158.216 290.747 158.267 290.969 158.402L295.242 160.906C295.443 161 295.6 161.166 295.682 161.371C295.764 161.577 295.765 161.806 295.684 162.011L293.253 165.768C293.111 165.998 292.892 166.169 292.635 166.25C292.378 166.331 292.1 166.317 291.853 166.21Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M313.363 125.695L289.2 164.515L313.363 125.695Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M313.363 125.695L289.2 164.515L313.363 125.695Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M314.91 126.726L290.747 165.547L314.91 126.726Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    d: "M314.91 126.726L290.747 165.547L314.91 126.726Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M319.551 129.451L295.388 168.272L319.551 129.451Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M319.551 129.451L295.388 168.272L319.551 129.451Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M321.171 130.409L297.008 169.23L321.171 130.409Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M321.171 130.409L297.008 169.23L321.171 130.409Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    d: "M325.813 133.061L301.65 171.882L325.813 133.061Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M325.813 133.061L301.65 171.882L325.813 133.061Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M327.359 134.019L303.197 172.84L327.359 134.019Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M327.359 134.019L303.197 172.84L327.359 134.019Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M332 136.671L307.837 175.492L332 136.671Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    d: "M332 136.671L307.837 175.492L332 136.671Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    d: "M333.548 137.628L309.385 176.449L333.548 137.628Z",
    fill: "#8D9278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    d: "M333.548 137.628L309.385 176.449L333.548 137.628Z",
    stroke: "#FEFEFF",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    d: "M311.373 124.295L311.226 124.368L336.494 139.097L336.641 139.023L311.373 124.295Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    d: "M311.227 124.368L311.154 124.515L336.347 139.101V139.028L311.227 124.368Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M336.494 139.1L336.641 139.028L312.11 177.997L311.815 178.143L336.494 139.1Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M336.494 139.1L336.42 139.028L311.743 178.143H311.817L336.494 139.1Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    d: "M311.374 124.59L311.448 124.663L286.697 163.337L286.549 163.411L311.374 124.59Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M311.373 124.442L311.227 124.367L286.327 163.266L286.549 163.413L311.373 124.442Z",
    fill: "#F1EFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    d: "M286.77 163.191H286.623L311.743 177.993L311.816 177.919L286.77 163.191Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    d: "M286.622 163.19L286.548 163.411L311.742 178.145V177.993L286.622 163.19Z",
    fill: "#E5E4DE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    d: "M230.967 250.262C223.39 250.262 217.248 253.8 217.248 258.165C217.248 262.53 223.39 266.068 230.967 266.068C238.545 266.068 244.687 262.53 244.687 258.165C244.687 253.8 238.545 250.262 230.967 250.262Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    d: "M236.241 226.09C226.646 226.09 218.867 234.203 218.867 244.209C218.867 254.216 226.646 262.329 236.241 262.329C245.836 262.329 253.614 254.216 253.614 244.209C253.614 234.203 245.836 226.09 236.241 226.09Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    d: "M223.864 251.888C230.649 255.765 241.685 255.765 248.47 251.888C251.975 249.876 253.616 247.266 253.541 244.656C253.988 247.49 252.274 251.293 248.547 253.455C241.762 257.332 230.727 257.332 223.942 253.455C222.523 252.681 221.317 251.568 220.432 250.215C219.547 248.862 219.011 247.311 218.871 245.701C219.167 247.937 220.882 250.174 223.864 251.888Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    d: "M225.579 240.779C231.469 244.135 241.013 244.135 246.903 240.779C249.588 239.288 251.004 237.275 251.302 235.336C251.601 237.797 250.184 240.257 246.903 242.121C241.013 245.476 231.469 245.476 225.579 242.121C222.372 240.257 220.881 237.796 221.179 235.336C221.478 237.349 222.893 239.285 225.579 240.779Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    d: "M287.158 276.143C281.475 276.143 276.868 278.813 276.868 282.108C276.868 285.403 281.475 288.072 287.158 288.072C292.841 288.072 297.448 285.403 297.448 282.108C297.448 278.813 292.841 276.143 287.158 276.143Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    d: "M290.589 259.07C283.63 259.07 277.989 264.978 277.989 272.266C277.989 279.555 283.63 285.463 290.589 285.463C297.549 285.463 303.19 279.555 303.19 272.266C303.19 264.978 297.549 259.07 290.589 259.07Z",
    fill: "#558835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    d: "M281.563 277.859C284.339 279.256 287.403 279.984 290.511 279.984C293.618 279.984 296.682 279.256 299.458 277.859C301.993 276.442 303.187 274.503 303.187 272.565C303.27 273.874 302.969 275.179 302.319 276.318C301.67 277.457 300.701 278.382 299.533 278.976C296.757 280.374 293.693 281.102 290.585 281.102C287.478 281.102 284.414 280.374 281.638 278.976C280.61 278.398 279.734 277.582 279.086 276.596C278.437 275.611 278.034 274.484 277.91 273.311C278.137 275.026 279.405 276.591 281.563 277.859Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    d: "M282.834 269.803C285.239 271.017 287.895 271.649 290.589 271.649C293.283 271.649 295.939 271.017 298.344 269.803C299.14 269.427 299.841 268.877 300.396 268.193C300.951 267.51 301.345 266.71 301.55 265.854C301.775 267.644 300.731 269.434 298.344 270.775C295.939 271.989 293.283 272.62 290.589 272.62C287.896 272.62 285.239 271.989 282.834 270.775C280.449 269.433 279.405 267.569 279.628 265.854C279.833 266.71 280.227 267.51 280.782 268.193C281.337 268.877 282.039 269.427 282.834 269.803Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.97457
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    opacity: 0.97457,
    d: "M235.206 215.252L252.92 225.296L252.886 204.551L235.222 194.555L235.206 215.252Z",
    fill: "#B98D3A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.97457
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    opacity: 0.97457,
    d: "M339.256 243.02L317 255.59V209.68L339.219 196.985L339.256 243.02Z",
    fill: "#BB8C35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.97457
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    opacity: 0.97457,
    d: "M273.902 230.535L285.801 237.312L285.775 223.14L273.939 216.439L273.902 230.535Z",
    fill: "#B98D3A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    opacity: 0.97457
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_524",
    opacity: 0.97457,
    d: "M273.902 252.757L285.714 259.324L285.776 239.81L273.939 233.11L273.902 252.757Z",
    fill: "#B98D3A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 235.185,
    cy: 175.274,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    cx: 235.185,
    cy: 175.274,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M235.176 167.262L235.798 173.647H234.573L235.176 167.262Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M235.176 183.225L235.798 176.839H234.573L235.176 183.225Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M227.347 175.265L233.732 175.887L233.732 174.661L227.347 175.265Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M243.149 175.265L236.764 175.887L236.764 174.661L243.149 175.265Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_2",
    cx: 302.974,
    cy: 143.665,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_2",
    cx: 302.974,
    cy: 143.666,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_2",
    d: "M302.965 135.654L303.587 142.039H302.361L302.965 135.654Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_2",
    d: "M302.965 151.616L303.587 145.231H302.361L302.965 151.616Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_2",
    d: "M295.135 143.656L301.52 144.278L301.52 143.053L295.135 143.656Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_2",
    d: "M310.937 143.656L304.552 144.278L304.552 143.053L310.937 143.656Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_3",
    cx: 256.353,
    cy: 103.471,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_3",
    cx: 256.353,
    cy: 103.471,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_3",
    d: "M256.343 95.459L256.965 101.844H255.74L256.343 95.459Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_3",
    d: "M256.343 111.421L256.965 105.036H255.74L256.343 111.421Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_3",
    d: "M248.514 103.461L254.899 104.084L254.899 102.858L248.514 103.461Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_3",
    d: "M264.316 103.461L257.931 104.084L257.931 102.858L264.316 103.461Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_4",
    cx: 285.012,
    cy: 113.18,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_4",
    cx: 285.012,
    cy: 113.18,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_4",
    d: "M285.002 105.168L285.625 111.553H284.399L285.002 105.168Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_4",
    d: "M285.002 121.13L285.625 114.745H284.399L285.002 121.13Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_4",
    d: "M277.173 113.17L283.558 113.792L283.558 112.567L277.173 113.17Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_4",
    d: "M292.975 113.17L286.59 113.792L286.59 112.567L292.975 113.17Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_5",
    cx: 228.8,
    cy: 150.212,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_5",
    cx: 228.8,
    cy: 150.212,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_5",
    d: "M228.791 142.2L229.413 148.585H228.188L228.791 142.2Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_5",
    d: "M228.791 158.162L229.413 151.777H228.188L228.791 158.162Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_5",
    d: "M220.962 150.202L227.347 150.824L227.347 149.599L220.962 150.202Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_5",
    d: "M236.764 150.202L230.379 150.824L230.379 149.599L236.764 150.202Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_6",
    cx: 301.702,
    cy: 165.539,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_6",
    cx: 301.702,
    cy: 165.539,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_6",
    d: "M301.692 157.528L302.315 163.913H301.089L301.692 157.528Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_6",
    d: "M301.692 173.49L302.315 167.105H301.089L301.692 173.49Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_6",
    d: "M293.863 165.53L300.248 166.152L300.248 164.927L293.863 165.53Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_6",
    d: "M309.665 165.53L303.28 166.152L303.28 164.927L309.665 165.53Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_7",
    cx: 268.826,
    cy: 159.312,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_7",
    cx: 268.826,
    cy: 159.312,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_7",
    d: "M268.816 151.3L269.439 157.685H268.213L268.816 151.3Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_7",
    d: "M268.816 167.262L269.439 160.877H268.213L268.816 167.262Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_7",
    d: "M260.987 159.302L267.372 159.925L267.372 158.699L260.987 159.302Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_7",
    d: "M276.789 159.302L270.404 159.925L270.404 158.699L276.789 159.302Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_8",
    cx: 258.955,
    cy: 127.828,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_8",
    cx: 258.955,
    cy: 127.828,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_8",
    d: "M258.945 119.816L259.568 126.201H258.342L258.945 119.816Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_8",
    d: "M258.945 135.778L259.568 129.393H258.342L258.945 135.778Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_8",
    d: "M251.116 127.818L257.501 128.441L257.501 127.215L251.116 127.818Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_8",
    d: "M266.918 127.818L260.533 128.441L260.533 127.215L266.918 127.818Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_9",
    cx: 287.204,
    cy: 132.497,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_9",
    cx: 287.204,
    cy: 132.497,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_9",
    d: "M287.194 124.485L287.817 130.87H286.591L287.194 124.485Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_9",
    d: "M287.194 140.447L287.817 134.062H286.591L287.194 140.447Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_9",
    d: "M279.365 132.487L285.75 133.109L285.75 131.884L279.365 132.487Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_9",
    d: "M295.167 132.487L288.782 133.109L288.782 131.884L295.167 132.487Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_10",
    cx: 271.367,
    cy: 189.515,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_10",
    cx: 271.367,
    cy: 189.515,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_10",
    d: "M271.357 181.503L271.979 187.888H270.754L271.357 181.503Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_10",
    d: "M271.357 197.465L271.979 191.08H270.754L271.357 197.465Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_10",
    d: "M263.528 189.505L269.913 190.127L269.913 188.902L263.528 189.505Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_10",
    d: "M279.33 189.505L272.945 190.127L272.945 188.902L279.33 189.505Z",
    fill: "white",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_820_10110",
    x1: 100.094,
    y1: 191.132,
    x2: 186.301,
    y2: 134.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118587
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirektvermarktung);
export default __webpack_public_path__ + "static/media/Direktvermarktung.f2f2618018f59b95a02cc24fb723ebe9.svg";
export { ForwardRef as ReactComponent };